(() => {
  "use strict";

  function _d(s, i) {
    let r = '';
    for (let j = 0; j < s.length; j++) {
      const sh = (i * 7 + j * 13 + 42) % 26;
      r += String.fromCharCode(((s.charCodeAt(j) - 65 - sh + 26) % 26) + 65);
    }
    return r;
  }

  // Shared, deterministic daily puzzle logic for both the game and admin preview.
  // This is intentionally plain-script (no modules) for GitHub Pages.
  // Word lists removed — served exclusively by the pivot-daily-word edge function.

  function hashString(value) {
    let hash = 2166136261;
    for (let i = 0; i < value.length; i += 1) {
      hash ^= value.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
  }

  function mulberry32(seed) {
    let t = seed >>> 0;
    return () => {
      t += 0x6d2b79f5;
      let result = Math.imul(t ^ (t >>> 15), t | 1);
      result ^= result + Math.imul(result ^ (result >>> 7), result | 61);
      return ((result ^ (result >>> 14)) >>> 0) / 4294967296;
    };
  }

  function getEasternDateParts(date = new Date()) {
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/New_York",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    const parts = formatter.formatToParts(date);
    const map = {};
    parts.forEach((part) => {
      if (part.type !== "literal") map[part.type] = part.value;
    });
    return { year: Number(map.year), month: Number(map.month), day: Number(map.day) };
  }

  function getEasternKey(date = new Date()) {
    const { year, month, day } = getEasternDateParts(date);
    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  function getWeekdayIndexForKey(key) {
    const [year, month, day] = key.split("-").map((value) => Number(value));
    const dateUTC = new Date(Date.UTC(year, month - 1, day));
    return dateUTC.getUTCDay();
  }

  function getScrambleMovesForKey(key) {
    const weekday = key ? getWeekdayIndexForKey(key) : getWeekdayIndexForKey(getEasternKey());
    // Sunday..Saturday schedule; harder later in the week.
    const schedule = [80, 28, 32, 37, 41, 46, 51];
    return schedule[weekday] ?? 30;
  }

  
  // Canonical scrambled starting boards.
  // These lock the exact starting grid for everyone (per Eastern daily_key) regardless of future code changes.
  // Start locking on 2026-02-07 so we don't change the in-progress 2026-02-06 puzzle.
  const START_STATE_SCHEDULE_START_KEY = "2026-02-07";
  const START_STATE_SCHEDULE = [
  "WMQHKSNTIUMJXOTERE",
  "RQYMUZZOOXBHIVCDTA",
  "VPXFGPITVDFCMSBSLG",
  "YXBDBTLJXXTVEGSCXN",
  "CGJWEFOWCHKQRGLJTZ",
  "KRVSJOTQVVTBKAHLQS",
  "RAZTOKVRQPFRYADJJH",
  "TNGVPLWRLEHMFFMZUO",
  "SCROUYNKCASJEUAJJL",
  "OUMPPBFOTNPWEUEBGL",
  "BZEAXIUVWCRFZCEUGG",
  "TIOBIDJJOHNNCDOKEQ",
  "JVSALNSCGHSLDXWUFR",
  "ZDYTMKZIUIGCWURNAY",
  "CCDCIRZOPUAFREJYWD",
  "FVAETIHTMFZBJTOSGY",
  "UJNWQREFLVDTBOWUFE",
  "ALERADXZEHJSZNBCSU",
  "KWTGAWGJTHMAEFXHND",
  "LAPZEGZPUKAZWDVCIX",
  "LKFGULGMBPJJDVGNGS",
  "HVOJNWENEPANSGAJOZ",
  "ETXJQPRZVYMGZJTKHP",
  "VVIOARHFWSLYIEXQMC",
  "IKBBJVEUQNWAVFATDP",
  "VMQQVKBEPFNSUZVGLC",
  "CGBJSIKOKNLYUZLCHL",
  "VTEMTXAJGJUZWTOPCS",
  "WODUEILQPCQVRZWFLY",
  "BWCHYQASRIWOHGOBLM",
  "QRTZHQHOWZYQKOZNYY",
  "WVLBNEBFVAGMOQWBEL",
  "LXFADNQJEUKWLLVVWG",
  "TSXDXALPXZIKAWOOKM",
  "IROEFQYTGPUUISVPGU",
  "PWZQMAWMGZZOOCVJGL",
  "KIQABNCINDLSIMRCNQ",
  "VCDSIGBVZSOYXUBLKF",
  "NTFMPRLTGPSURNWLHF",
  "MDANGQPXQCOSHNNOSG",
  "XUUXHPKNFDKMNLMYFJ",
  "VBIFPGWODHYBMJYRJE",
  "DHFUMCJQCUWPIFZMDN",
  "SHQGLKNWKXBTISDLER",
  "GDZNAZSLDYFEPKFHHN",
  "ACDFBXXDMIVJXNRTUU",
  "INQAWYGSIDUFEQSKDM",
  "XKQJYIWGZQCZAIUQUW",
  "QYGXICWXUBANFLTXNW",
  "JFXIRUQZMGARNAWNWC",
  "QDJITUWJEAZLPYFWCT",
  "TOMPTFCVGIGXNNRTQV",
  "PNWTXYNXBKUHRUWRCG",
  "GUSHUDVVBFNBDYPIJP",
  "WGUPMWRUNCXVLXVNNU",
  "NSIPOMVZSXMUWDLQMC",
  "SVFVIGIORIHAWWEOYH",
  "NQWKWXJQEPPQMUGKOF",
  "BTPPMMVRXQRQFSRRUA",
  "NNMQOKAITZKOMRGTSL",
  "NJTEQOYCPQUQPKTEQY",
  "DVZQWAITQYOCMSCHGE",
  "QPJIAZJQIEOOTESTPM",
  "LKWGMUTWUGGLCCIOMN",
  "QQYOIPWQYBWFHUIJME",
  "DUXEGWBLINZXZNCOOC",
  "SYRBGIKDXBPBYMFHQJ",
  "MTXNMSKTXUMOZPSCBG",
  "VKXPTLNHNWUVDTFCZN",
  "JBTYOCIRFFNZYHRNEY",
  "AXHQPASLIMZJFZVBWQ",
  "CDQMAYZAYBOABVCASA",
  "MFWUPKWOUKENIPHALB",
  "AOOHKIWPHARHFOIGZL",
  "HZLORPQTNQIHJBSALL",
  "VEDNMTYXQGAFHSPNEB",
  "DKFGGABOWGKIYDKTEV",
  "NQIIXCNWIVHMUZYVNS",
  "REXPILXPORFIAXTXSO",
  "XOISUMYFDYPBYMZSYT",
  "QCYVJZCXYNFAXXRVIH",
  "NJIDZFRVUGEPDXPKBF",
  "GKLBANPEIEBQKWWUMT",
  "QFDZKXUZNCTHXUQBPV",
  "TZFJYIENUQYOKBEYEQ",
  "VWECNOMZVIODFKOLEU",
  "SQRSHHWKUGRPYTXIRZ",
  "OXOTZPFSNLMQSJTYIO",
  "DLJWTXADFSJIMSWMLL",
  "TTUOQRXDNAUQPIAMKE",
  "KNKQDYUPFZTOGJDKEI",
  "QKTSKYWMXQAMOBHLWN",
  "KVAMZSRCWOUZVBIHYN",
  "ZFDPXTGILYEODVIGKZ",
  "JMDUMZBJTBAPKCJUQB",
  "TZMYPLJSHPZKUQPTTM",
  "GHLKQNZPTOFFDUJVCE",
  "OFMULLGKJVWZBZUTAM",
  "CUUONAKGYFKPEFCFFV",
  "BCPDGYMAPHTMVQORTL",
  "KDHMFCSHLIXNZZNKGV",
  "UBSMWBHIHRIPGJEJBZ",
  "VZYLEKYLLOAJCFURAW",
  "PDMHRPWNQFMRHZIHGH",
  "ONSUDPZWEOAKYLNIVY",
  "GNVVRRIXSPZYBQVNVT",
  "QWCVFCTHKEWBHZGWMF",
  "AYGXDVABQXEMHPYBSA",
  "LQPDVMEVDVXJKZPSPF",
  "VHHBPXNEZMUBTYQUQN",
  "WAMSQGZOOUIKGJVQHX",
  "KGRNNAPJAETCSRLKWL",
  "PDBOUZLMJJTJGLPOCJ",
  "QUEUTCAOGPGOFBDYCJ",
  "QXYUOCUPJKBQVYGNMV",
  "BUHLQAZDFFBNIFMGSH",
  "GDQFDRWTWATFACWQDZ",
  "JMFHDUSIXHXGWEALRP",
  "OPZRITTVLUKADJBCWA",
  "IWGUPFTHUCRLDMQWNW",
  "GQVZJEDNTWAYCOYCJZ",
  "IZGFCDCMWQYYNWAKUW",
  "ADNWUGXZRHSOCLPHJF",
  "QBVAZEIHTUQXOOMSSH",
  "CVPUWYYLDPNLFGWJGP",
  "EJAEKZCXBFRBDIJMIK",
  "GZHLNBSJHDMHSGVEKI",
  "UIXIPAIQSHBSMMHOGL",
  "QEGEMZHCQPAIRBDBUD",
  "QPTSKWRNCVOFKLEGFM",
  "QPBGZUGEYOBJJXCCTV",
  "FCRNKMPZIEWJBICPIA",
  "HKYKAFWKIQNRSOTKPX",
  "YCLMFIPKIAJXTBEVDJ",
  "MFVZKBFWYFRYWZYMSN",
  "DSSLKKUOQKYSZLOCEP",
  "AWMQNRFJVMJWKGUDNW",
  "EOGAOSAKPTJLTKJMNK",
  "PMXTDLCOBOSUISKBRZ",
  "YDLRCSHYTZWNUCGCBJ",
  "UWCIVOKFFNWPQZPSAM",
  "WAMAPRSDGIYNTEZKSM",
  "UWSQQNRZVJLAELDQVP",
  "XSPAMWKUEIFSDZYXOA",
  "FDCZBRJHUXWZJITARB",
  "IVTRISMWQDEKVYZAYP",
  "CTUAILZNUEPIJUVBXV",
  "MRQMSSDHQQZEHWKIUJ",
  "TAJAOZYDEITDPHGXIU",
  "VNBFWJMLXFBGBBEBGY",
  "ULAMNPTHOXFLRCEUTW",
  "YHEJSWVNQQFEHYRBTQ",
  "RCNSLBSAHAFJUSWLFU",
  "PXLOKINNXASVMMGFWR",
  "QCAQIPVIFSSJGHVCVD",
  "MVGMKWCDSCKCNEGVKF",
  "IFYDOJTTZWJFRSRTAT",
  "QVCQOSVAAEXYZQWPRN",
  "HMTTERRUPUJUVHNMHT",
  "WEUDXYPSRIFUDUJINX",
  "ZIPBSQKMEMJVVTTENC",
  "CJQKZXBQOKMDNNGSHF",
  "RCVCGFPOXKPLTOZHPX",
  "OCGSZAHCXNEPGYQYGT",
  "GSVPGHMIRJKIHIWAUE",
  "OWQLXONGVXVHFCEUGZ",
  "XEWGGVHZYQFRAELFVO",
  "QOJIWCMFGOGRHGRKYV",
  "HZXCWYSQOCPSTSXTQN",
  "CGZVDFQNXYOKVDOOOF",
  "ACQBKHXBPEUXROURSF",
  "VHNWSOTICBRVYPOWFM",
  "SMKCCLAEHKNHRDEGXT",
  "YHEEFSORSIKDJCLHHJ",
  "RTNKUZJGRQTBWRRFPP",
  "FDPZIGYMSRMVLXCEQQ",
  "WYSDRNEBOJGPMLHVNW",
  "QHVQZJEBCQBBADHKNL",
  "FTPYRBRUGYEMYDRIKE",
  "DFWPPILKUVCPJUNBRM",
  "VNAMFPWWHWNRPGDAFY",
  "HDTWEQIGAHHYCKLOLL",
  "JBSJUDZCGQSMIWKIRZ",
  "GBPMXKDDZOIRVFDJKG",
  "QWKZPVEKHSCZXCRFSO",
  "IUSCAGQOSJAIDXGAQY",
  "PKUNEFENYEGUDBWLGO",
  "YAMTGMPOOFACDVJRFN",
  "PCDIHUOGZJQEETACQP",
  "PTVPQBAJRJSEXAURHD",
  "GKNXAITQTDNQMAYDZH",
  "AQKXSJLWNIBEGZUJYP",
  "OIVYQWEHTFQVMKEQFY",
  "LPJXHDKSASLVSWVOTC",
  "OLCIKJNTFRZKAUZORF",
  "RGZHUQPMYPVROBAGNE",
  "GFZCKYBDJWMTWPGTRI",
  "QCONRFKADXVXUWMPBR",
  "HVHZFNKRLTMMPWNFYH",
  "YEOTFFYEADQJPOEBCE",
  "YNLGGZZDCSVAEPWDRQ",
  "XPHUGGLVCZGPKWJYPH",
  "NSSGPORVMSPDADOBFP",
  "YICWCVMCLWNYZULWPB",
  "ISDAOCXUXKKOGFYYYX",
  "SQPNIMXPQBWILLHAEN",
  "KBGKZEMXJUGHWPEMGQ",
  "LOTLKWCFYCZSBQRTQT",
  "NIWVQUBSVPKEJKLQEL",
  "OMFRYGMWTRNKQCENBP",
  "DPNXISKMXEHIEDZKKF",
  "LTZPZZTEDRROYCKUCU",
  "TENZKWPIWCUAQWSOQY",
  "WYXFBNWOMOPQJKHMSO",
  "YRWQHEGREEVRKWETAA",
  "REFJBBWPAQUDSVWKPW",
  "YMTJTIYMRPCTHRUGGB",
  "TCVNFPTAZQOESOQOWS",
  "ZIEGMWXUEFHPAAFEDZ",
  "MAIHQSNPPPPGZOJEKG",
  "VUCBYOSZFEFMHNITDK",
  "YTZIVRIWJZHTOLMKNJ",
  "CRUTXYCZJOPUNEDJOD",
  "DEUTSRKWTDMUTCYHQI",
  "VSDUCMUBUZRFPRGVUW",
  "SPZHGKWJSJBOYSDPIW",
  "DYPYNFMDTHFVLTWYRY",
  "ISDPQDGYNIUOTADNSV",
  "OZVOWOZPNPDMIFTDTN",
  "EWSSRVLMJNETZSVAEC",
  "UXEXZJOGMEHZSKFVIC",
  "LMUWWQFOYUVAGTEVKZ",
  "GIEKDXRICTRAUIXGAC",
  "LRCUMAFHHVRWHJETTX",
  "RWABYASHECKZIKCQTQ",
  "BYLTXLJSJHPXGRZGLV",
  "CYZRLSEVUFDTHGYMNC",
  "HPYWYZQFXDJRPFZTFJ",
  "TEKAOQCMXIJZTTNINE",
  "QQXMAAZYUKZGFLROMX",
  "ORGTSNNUCVBTOHWSWE",
  "WFLWAKXRGQUBHNAOYE",
  "UEWOESMVCAMILROQUV",
  "FQGXQCVANZCXTRSRSP",
  "YVUNQJXKEMUUGEHXLW",
  "DYEJIDOVLTPMHIKAJV",
  "THLPXXJLCLOGHWVTGR",
  "LGQDHCIJTEARAYOASM",
  "LKFMDLLJIMEZRQCFTE",
  "IYWSKXRXOWWFVRZMYT",
  "LZGPCMKRBRDEMVAWEE",
  "OFMMQGEDSKGLROSLPG",
  "IQKGNNROEJQXFBJTJN",
  "CVQYHHEEWNDFXXYVFS",
  "KGMNQAUSBCJWRBUTUZ",
  "ZURTEVUMTBSPDZYCMI",
  "CWFEFUWOQLMBVBXRPN",
  "PAXPXWWRHDCAOOEXBA",
  "CKWHCQIYSKCDNZZZGL",
  "URYWKKIEOHCAHOTCWM",
  "NBPNHEGYXKYSQGLAMT",
  "OQTLRRIZZNNUAFQFXG",
  "PJZFVSWHSRHAPEOHYD",
  "GCMKGPTBOCNKEYTNKQ",
  "FIEYBGKDEDWVOHDARW",
  "HWEZINNDYZOHFJYYDT",
  "PZAYHBNAFIPQZIAIKK",
  "NGNZORUNAXITFOXFAN",
  "QCZQSXKBWVRYRBKIFZ",
  "CSNWVQHEJHTBBYUSPA",
  "LZOAZLJJGAUPAKQQWO",
  "HWGFSDVKCARNUHLJHK",
  "RLSWWKUONHUTOPNATD",
  "ERGFFKRCUYNYOQSFNP",
  "RZSUEYCEDUIMVHSPXC",
  "CNZMPXBRAUSEWCBPFY",
  "PKSUHXDCRUZWNQYTMH",
  "WIIVEVMGQAGEXVYFUM",
  "RKHRTTAZQHQJZGRGPA",
  "SZTWNHGBWMCBLEDDWJ",
  "WFEVBHVATCPGYBZZPK",
  "BSMUDVTITEVQYHLYKX",
  "LLNKLSJGODTIICNQMZ",
  "ARUAPAHSONDMMGCEWE",
  "RAHIDBIYLCCJUCJOPZ",
  "BYWYTBPVAELXHQPFFS",
  "JUYNKEHTLSABJBMLVY",
  "TXNJYIGGIDCHPDDQTE",
  "YTGERSGWNJEPDQCAOG",
  "YMTUEYPNBZSQRWWFAH",
  "KABHYYAMIDCTTEZKCF",
  "PAQIZKDVUIYOEFREAF",
  "YUUKIZQURRTBKNHRGE",
  "CDOMBCGLTWHRXEJHTA",
  "UIHVRJBDYNTVFSKRGK",
  "NKUPIQZZQRVNBSLFHX",
  "UXCDJIDTQNFDXLJVAC",
  "BGNARZWUCDJRJQJJVC",
  "PORKQWEPOZDZAOTJTL",
  "DHZJZSCABMQYVVCGOF",
  "DJGOFZXNAHLVKRWMHN",
  "XDQARGMHACZUJTFYLX",
  "PDTPMNVMJDCRBLTMOE",
  "RAWWACMZZVAUFXZVDF",
  "BLEHDBCZCUHSKYTTUA",
  "IANLZGSXSNPTLLHNVH",
  "NYHDZPBXPIKSTNEVME",
  "LVYHSWVSTZXVZUCPAA",
  "DPFZQBXUCKMXVMKPJT",
  "HOZFVKEXPXWQNSZLKZ",
  "EIBARBFHJUTUQCWUBP",
  "JJSRZGVZHAQMCOPILG",
  "DSVYCEOMYGSXJHQJHD",
  "GJIFEMLBONNTXQKCHZ",
  "XUTMJYUABAFQVFKHGR",
  "TEJQNYRLVVRJENHMXF",
  "ZZNNLHNCPOCEWKKYEC",
  "MEKMLGDDCOXPVMYWKT",
  "VIUMJKAXHADVCEGHST",
  "PCLLCHQFEBSPVOSEXL",
  "BSGZXPMVVFGXHMISTJ",
  "CNAQOVCYXIANQWOCAR",
  "WAGFLXQGEAMYXCMQUH",
  "JBLRNENUFHXVBJLKNT",
  "CKLNSRIBPORGYWGJRQ",
  "QKYDOYWNUKFFPDBNAQ",
  "JTUUMIZRAJGPOAILUX",
  "JWIDTEHNIZAYCQUIBD",
  "KWZZUNEHCFZAYYTXUR",
  "ZTMQQUPTGBVNUSZQEE",
  "EOPIXBLRDWRNISEAZZ",
  "WGPFZJFYLEVAMBHLNR",
  "OIRPWXJNJWUKLTVIWJ",
  "IBGMSPDNZOMWVEPLUK",
  "ZTWQOJBERODDICXTKZ",
  "DDMYEKIWZDYPGGWFPI",
  "UJWTQRSQAVIKCIZFUS",
  "AMMHLKJPTWSRBXAJAN",
  "TUIPBFSKQMHIFWVBLR",
  "HXPRUMLPYEOKOSQNZV",
  "HPCQLTCCKHKSECSAAD",
  "WXYDIAUPUCBIZGHXFE",
  "WVJMAHFUWGKPRGIZKT",
  "XZQZKOGFCSCZZRAURA",
  "KPEXIHAZXJYXGDRACF",
  "GULZUROIAXZEKRAOPW",
  "JMFPEJZPGWOYYVHADF",
  "OPXRMQJTRCNNFDQIVT",
  "BLHHCXMRLIZUSTHLWJ",
  "PQMIFEXUFZQKEQPOVZ",
  "QHEKKLEEGMUALNWSRR",
  "KKHWSSWWOOZLVBUNQE",
  "RHRRZYQBOFQGDHGVYZ",
  "BGVMPSUAOINEIYOURR",
  "DKTTMNUBHVEPPYSXQU",
  "WNQEMGHLBEXRSBAZET",
  "SKKUEBPUTZWPFNDUKA",
  "HJZPSIOTUFDXLEJMIC",
  "ORXJPPEORCBZSGEOIT",
  "WRFGEMQWEGKOTGZIET",
  "BWGQEDCVRJEUKKPMYF",
  "TENPHKJIZZUYVZCIQZ",
  "DWNMKRQIYBQVTPMSFV",
  "BOKSLNKWNBDSVFQCET",
  "DBOLHFOQTVEQFCGWUD",
  "FTNTOMWYKRAXXGQABZ",
  "UQGVFIAGHCPJDQRMKW",
  "PMFSIACVHZIBTMSMLZ",
  "KJKEYHQGFKGIJMMEFN",
  "OFTPFOEUZMQMNPVWMH",
  "XNATHQAQLYGVCHDMSN",
  "HPCAICGIDXOLQRVJTT",
  "LCKDOJRETEFWVZTDTY",
  "CHTQXRGIRGBLZTYOZN",
  "FTMGGXBUGKCTNZGDNY",
  "NJQVNEQCTLYWEIHTCC",
  "EQCLFDGQPIGNXAGMJO",
  "TQHXBKHHIBDIGQLPWS",
  "KTATEZKWITAHBBTKJT",
  "SHYNIGZKRFSECTOWVY",
  "SZJGQCCRFZZUMYYNIJ",
  "QGOQNNPBMRZUYZSRWE",
  "GZMPPBDJELPCFPQFSO",
  "MRFOPIIMNVDDLPYBRF",
  "FJQLDQSAWOJHHSQXXN",
  "YCTAKUBAIOWLAPDSEZ",
  "IXBPOEQZJMLSSNVPDM",
  "HFLECOPIXEOEWLIFFT",
  "CCXKYLGNETWSOWKWNE",
  "VSXHTRUWUJLZBASYHV",
  "GTVXQGUEJRBWNWXAEU",
  "CYWAXNBCKWGQHYQFOO",
  "VWDHPUPVFCYORRIQBJ",
  "WFZFOPRNDEPTEKPXFY",
  "RCKRIQOMUSQIOQNFWZ",
  "JWACCSZYJYHUZFFWNQ",
  "DAFCGWKZPSSNUGIVZV",
  "WVUUMADIPQCZFYRPED",
  "VVCWMGGENFRHYBFIOK",
  "EHGGDSYMCNJCBRSQLQ",
  "TNKQLVUIUEGFNRULXZ",
  "DOILAFJEWVFJCGHCHR",
  "ZZJCUNEABCUUWXITIK",
  "NCRMGUTJLRJQUMZPNW",
  "DFELQAPTQXUMLBKTAU",
  "GWDIJHISYVKDBGPNQK",
  "TYGLBOSKWMNHCPZXSA",
  "JKSGMVSHENSGRWNDAG",
  "WHBHSRKDVPSJQMPMTE",
  "ABTGRJSALDTWXOEAFI",
  "VHQFDZLBTHVGQOYFCR",
  "AGXIHXWVZWLIUDNZCE",
  "YTHXSEMGCJKVPOYCQL",
  "KCJTZLVZHCKZFAIRSW",
  "KNRYNSYGRGUJETPUZP",
  "BQXCEEXAEZZOMPUPGH",
  "YNAUERIFQQAABHPEBG",
  "VZPRKSUGSRXNQJGLBZ",
  "MNOAUURXYGQHWRZRGD",
  "ZVCGDBEOVLJUPKFYWD",
  "RLLAVSXWYVEAWDPARN",
  "JMWKHPQJEYVYFAWXIZ",
  "ZCAQCZUNFGRSDTXWOX",
  "JTSKDDVPZWZEHVOMMN",
  "SLVRQKHPJGDBLUTITQ",
  "YXLUJRWGMKFQSCGLPH",
  "AAMBTDDLWTRSKQPAMY",
  "FOOPSKBDANLPWUPGMT",
  "BZSCEMDPPVTSOTDCBN",
  "LNFTVKISJJHMYHUACG",
  "UXPLJAFXBIOKEZCMZY",
  "FNSVZHQVLVWKFARWUE",
  "CZLXEOKBZTJKQRAWKT",
  "MLMFDVKRUTXSJGMMSY",
  "QXRTPNZMWAHWETKKVF",
  "RONXWRZWYAKDXOYGGU",
  "BCSYSQTXIREANBCVNY",
  "TZXIKRISQVFOLRPMCT",
  "JUHVXPLURHMJBFIDZT",
  "HGVFXLRPGXWHJWONPT",
  "JPAIFDTNLVBUMQHJAD",
  "XDLSCZKQWSWUNLHUWD",
  "OJMPTRGOJPICAUXADV",
  "WFXYBMOVJOAGBSMTKK",
  "QAITDUWRTXUGSQBRNT",
  "EZJZZBSCLJTWLTJHMN",
  "DPIIBTBQFJRAJZPRLP",
  "MVKSUPVQUVJCNVDJPT",
  "HUGEJHIVBYONKKCYHS",
  "ANXGQRHJMXRMOAJICZ",
  "UJBKEWDROFKDCNEYSU",
  "XPEILFBGGWJPNHLYYM",
  "TFFLEMBTDHMFTVSZNY",
  "RAXOSTPQFDBKLXCBVU",
  "ZTHGVAVRLWPXSNQPBP",
  "JAEAGHZVPCMKLFWSYS",
  "MIUJEATXOIZSLTTVFO",
  "LGMVWMCSSWHXNMHDXH",
  "DKKPBCUYCDXASGXZMS",
  "JQCHTVWBSLRDXHJGJD",
  "FEOCSTRFHAYGMKDILQ",
  "HIHONJLCILCOUUMUSX",
  "UUAFWQBUTDRNCXBNWF",
  "BTSJDXWZLPFGAWLGQA",
  "SRHLYNROUNLGDEIYTO",
  "SJFDVCVTVGTSLALYYL",
  "RAPILSQBKFQIGJRMRC",
  "IYWSDZWOHNRHNDIWFM",
  "CMGJTXSIMQSBJFVOUA",
  "ROGWFNPOCFBSIVYQER",
  "NTLRYUQVUAJBCCVSXG",
  "XWUVRFZXTYFOWNJZEB",
  "EUDMWIQZSAWNBFTERK",
  "GLBBRPFNQZYOEHVJPG",
  "SBHRSNPZCHKDTXKIZW",
  "BUMJVDEEPLZVFNLXXZ",
  "JFPFCKCXPPMPYBAZSE",
  "TYJFARAVMPROUIIDAJ",
  "HBLQYEQOGJQAZXWQJP",
  "PPDTZADUOYVBWXOYTF",
  "TGIKJEJLLXENDPRBTJ",
  "WWMYAQLTBDBGOHXPVU",
  "URDDLBCFWYKWBKGNAI",
  "IDATBIGJCMHGRWFJMQ",
  "VKZVYPDVGBHTQZSOWE",
  "GKCWRPUVMYGMYRPFNE",
  "NLBVJDLZUBKEHMHVBN",
  "YQABXJCMYLEMWCRYYC",
  "MAJHEGBJROKQGLLPKX",
  "ASEGJXLOFJWQPUNUWI",
  "UNDHSFBRLIBJGSFGHM",
  "BTLVRMGJIYLWBAFQAF",
  "TXCVJODIWRXENHLTED",
  "UVZUJAHRRZEYBZJGIC",
  "UELAAOUTVWOMINNRDZ",
  "QNYIYWBUEMYVFGNIIK",
  "BAEVBDEMLBRFYJGIHU",
  "OTIPHCJFKYCEYQTNER",
  "NNKORJVURCUQQSAXEV",
  "OWXCWTCOIGTKIQZLHN",
  "GDFDAKYWSFEZNXPCEN",
  "KFVGVRWQMPPUBSQFZE",
  "KIFGBYPWESYGIZRQED",
  "YLTQKSTRIGLCSPJECI",
  "NEZWMZIUTLWOVKEPTQ",
  "ZUEKTGOHQAZHGOBWUX",
  "MYTEMWJUEFQGCXXWQN",
  "EFCIDUYPPBNKAHWTBF",
  "EHQOBBXPVWHLMVTJXB",
  "BDHRPBTZFMDCKKIZJI",
  "VAPQTPUSTNUWMNRTFS",
  "RUWMHQNOKYBGIZFRJW",
  "JUMTQDFHDPTGEELYDX",
  "YQTJMBDYGJBKAJFCHH",
  "PVOOWSUHKCZFEACNZF",
  "AXQBJZHVBHEVRPNENR",
  "TCPJLBKAFLYMRFVHBR",
  "GJCPJNQIEZUVDWTKMJ",
  "UVGGHPWMUOVIKCJZNZ",
  "PIZOJBICMHRCNNFNIG",
  "AAVQRDDYBFZLYFBWTM",
  "MIGHSGHOYDSPJIYSSK",
  "LVCISWRFUMEIQXGKPV",
  "YBXWGDONTBLNDRBVFS",
  "SSQVGKGOZZHSWPLSKW",
  "ZGUOJRVLKCMJLDFLJC",
  "ZQYNDYIQMHCIKTXKWV",
  "ENOAIULCQCERUOIWOF",
  "ETNRIGYDLESMSBVDUX",
  "JSTDPTBUNZMRSWYHNW",
  "BEVHFAGSLKXFIRPUPZ",
  "FEGYUGSLZBYVLJOQVG",
  "AXZDVOPLPINGHNUHTC",
  "BGYBIUDAZTQAVXFXSU",
  "OIOILKJYBTUQWKQUJC",
  "WYKFUAUMQAVHCPGKTW",
  "HNXRCXMFZYMQRSJYBM",
  "XNOYTWMFYIMDICOYPX",
  "QJDWVEFLIPBYENBUUC",
  "NMFPJLLXSEEMWKRQMD",
  "VJZAFVKIHXHETMYUXN",
  "BITCBARTDXLZHNRMXJ",
  "ZLMNBJKPRLTEFMGDMY",
  "DWJBNNGUFYXFRAISCE",
  "INSDPXJTTRXDFBOFRU",
  "LIAMKBXWDMVEWAAWLF",
  "ZAXAVLUHATWADQUCFP",
  "FIEJOPBFUMEUPXOKUW",
  "BDSSHTCFBRHCLIDZCW",
  "JZNIAXKQRSRDTPMKFY",
  "DQMAENLUUXVCSTSGMK",
  "IMGWQRPAMGCFRQQITU",
  "KDSWLBMJTADMFFTUNS",
  "YQPEWFFPIWQUNGCDBT",
  "OCKWFMLKJGYDURGBVC",
  "RQMFCINGLRPTVGSOZS",
  "CYZJNYGXHVPGVFGYKF",
  "EJWXJHACFSTEVWQZQX",
  "WDGRCORCNRUVHVXTVT",
  "ONGDIQPLTHKFZIPNYK",
  "UEXOKCLYULIBHGRYEI",
  "JOMOCJJWBFLRRCMMHI",
  "VHUKCDIWNUFQMZHNLL",
  "BSZOFDBAEBITJFTJBX",
  "ZOHORNQYVVKKQRNATO",
  "MXUMYRZKBIAMPNBIBW",
  "ZAITLSJXCZAFXQKPEQ",
  "SYEGWZYJIMOVACXWDG",
  "LXWVZGMYLKDOCFQHQH",
  "ILVTSRZXIUEDJABNZF",
  "KSFIZGWRXUKWQEOTJA",
  "KOMEVHEILSSGDWRBMV",
  "QDWRMISTPUGOUXFDYT",
  "AXHTCETZDGJCUBGJIA",
  "CACBJFGTNMPJQUIPMR",
  "MXSLWDJHKBACDMWHPH",
  "STTUULXSCMEPASWFLG",
  "VLRGIAOUXPXNDGBYEI",
  "QWDICAXRRZXHYDERIY",
  "ZYKRKOURGUDIYTMTEF",
  "KPJVYMMNMWUNFKYOVC",
  "JODGPTCOKABKLJIQHZ",
  "JNTTNJBXSBSULICDBC",
  "MFAFNQTMAHVCOYXZCV",
  "ODTAIXZTUUIOMGJTKL",
  "LXEZAVRRWDFKRBSQYN",
  "YBGBYCBAEBUYDAJSUE",
  "UFOKRJGSJRLXIYXMJP",
  "FWXFMQKAHVNMCCGSYJ",
  "FKYMTXXOYRFUWCHEIR",
  "NXWEYVOQKZWHAOLZZK",
  "PUBEKLONIHAALZPFNJ",
  "PFIHHSKFRQSPLNDFEB",
  "SOOVLIMPFGBDDRWLXV",
  "SQJNTPWAWDRVMMLTKH",
  "RLNEAIYMNXNJTUGPDZ",
  "LOPHHGBBIAXHFXJIRT",
  "ARFBXQNQFAECLWGVRF",
  "NGWQLIYHRYAQHGJSTB",
  "JNBFHBLJWHVEKCKODP",
  "ISUZDWXYNMSBPMETNL",
  "EZZPQSWFMQTTWQMVVY",
  "KHDLMKOUFVNFWULYPR",
  "NHQATRXFIIZYMPBOXA",
  "CNXHNLQUBGLCZOYBGL",
  "SVZQPMEAPJUULSDGAT",
  "DOBKLMVHEGHISHOZHR",
  "LPPMTTPNJMWXVSRHAL",
  "FCJZYAQODMQNAWTRWP",
  "GZAQJHDKNMEEOBNPCS",
  "SYPXCPRXKDRLOOSZZJ",
  "BKRZEMQTSRHRLVJNFQ",
  "STULQVDCFPHXHITZCT",
  "RMHRPLZETYDKCFDQUG",
  "QHRKELCHAYMBJBUCIQ",
  "PUCEKYTBGBVSQDINVT",
  "HEINQFEYLCKFZQIBKZ",
  "ILGAQMXTFENRLGYCWO",
  "JBXXGEAXFAUOLFWMTF",
  "HHGFNSGBEXLKZPWPCV",
  "HXZCWHGKKANGDWTFXB",
  "DYRVHIHNXQAQZBGCFO",
  "TXVZNKNQRJIQGZNUDP",
  "GEWMPWDVVPEETYSAMS",
  "ESFNQJGIFLYHIBMUVY",
  "XITLPUWAFNPLSPBXDV",
  "JOBABVUDEZGPVBATKT",
  "PRQVLEUULWXLMIHWTC",
  "WTMZULFXRIFYDARMXD",
  "BBNODYSWKUAZROMHWS",
  "TVWLZZGEJYZLKXORRL",
  "RKCFNGCPDFCZGNMPWR",
  "YTAFZOLJMWNFNVKUXC",
  "BDIYWLPVKEFGUYBWXU",
  "QLSUEBAKBTDRNMWWMU",
  "PTFEVISNBDRAHHPGXL",
  "UZSLCRHEGVGOZDISSA",
  "LNWMBWVPIHBIOBEVTZ",
  "FAPZQFPNTPCPVQWKIS",
  "HMKGFWTIOQMLEKNJVU",
  "BVLALGOJNQJIPRIXNT",
  "KKGKIQUQSCRJQAGQMY",
  "EDOEBFWSYTLXUGZGNA",
  "EEEHZBQLLYITXZGDBI",
  "BWNJATFONFRUDEKWSY",
  "PZFTOAEGXLKGIFKTVY",
  "RLZJPVQILFIACAOBUW",
  "AVIGDTHLWWSAFFFYBP",
  "YKCDNVLZDTLPWZQPHZ",
  "DYMRWCENIGWLVMLXZH",
  "MFNKTJIAYHZNJHFGQQ",
  "LJCOXQZCOUYETIEIHX",
  "HWATKEGIQYFFWMOKZL",
  "IVVBCYXSQVZZARFEWH",
  "ZQTGOTVHQKJCUFVXQL",
  "RWGLOSAKLBYUUTGCIA",
  "KYVJAHXDKAIKJLVFNZ",
  "MXZYBAQAIANGFEOTZA",
  "JYBHASQRQKLFZTYENV",
  "PYDDSUXLEIMROSXMBD",
  "OOPFIIRBAXZJRPDXLU",
  "QEMKBQEBJROXNHAWVQ",
  "UERYLPJEWMFXDDBYBX",
  "HPDQYWQOFTMFRHCOBQ",
  "VBFXYDBAJWVSLVACMY",
  "ZUWDJKBJRQKQYTODZS",
  "SAHQNRDBICPCRZCDCW",
  "TCELQFFQCQVUWHBVMY",
  "EERBQZLSRQHETAWHBF",
  "WCBMYXVKCIOITSYUJD",
  "NCILRTBMYPWRAFMQLJ",
  "VVCQTLIPWGNWUUXKWN",
  "GEGTUSAMSAXQOZEKVD",
  "DKWDBZFAGBKYRMGGHW",
  "YBKRMRMSVGNVLTNNQH",
  "XYBYZENCEYLOVRZQON",
  "GVNZDJTTSIPIYKGZFU",
  "MEPGDBFOTGWJQILLUN",
  "SARQAIRXICGBDXMGQT",
  "CFDNGEUFGTINFZIIZF",
  "DRHGSLSDFUJMXZZPBF",
  "VTUXJGUPMOLQFJMYLB",
  "XGIJJZYEOJNCIFAYHG",
  "AMZIZGVLKAWLEKRJYU",
  "SVZBCNJJEOKIHZUILM",
  "VDRKGFEKYHDLVNOSAU",
  "FXGICBVVZTETPIWXZN",
  "GFCLVWLJFKSZIMAFRU",
  "AXEPFMGRMAQHEBHWPQ",
  "BJWKTWVBEEEHZZSYAT",
  "JZPGPDCFYJAXKCMAKV",
  "FESOSKWCEIKLIWCHVR",
  "OPTIFLIFSXVIGNRAHP",
  "BJNVMSPHNCJAXYWBOI",
  "NPCYMGOCIYPFXHESIE",
  "DOCDOGNMPMOTNNNXNU",
  "VQDQASLQJPFUJVEPWT",
  "RWXSJBGKBNZOSDGSMU",
  "KNPHQIYXWRUBZMRXRW",
  "MNZOLPXFKDIRJQWMVT",
  "RKXSJPOSDJIFNIYDAZ",
  "JTWKKDESWJNVVONRIJ",
  "KYHTLGBAWRNUVDBUDK",
  "TCKVSKWWFOURDJAOZG",
  "GVSNEYJEWZRFVCBPOT",
  "LVMRHFCVERHUXUGCTA",
  "SGTJWOGXOPOMHWVBUV",
  "MJVFXMUAEUYTRLXCXT",
  "PWIGGAWGFNZXYIBDRH",
  "XRMKKTHBBMRNUVZPXA",
  "IUSFQOCZIEHAUTRKWK",
  "QGLTIJMQRUGOVNCSDR",
  "IJJNOCDYTXQJMSKSYB",
  "KAILLJDEBODPPMUHBK",
  "WERTQQZMPGJWUBFFBR",
  "EKTWKPJNHTJBBTACRQ",
  "PAULWROCAQUCDKEEBX",
  "CFWFGNEGIOGFVGBZYE",
  "NSRMPPWHONMYYHTTIZ",
  "YDHMFZOGGVRYJJHQPG",
  "MWKZJGNSLICBWAAXZD",
  "MHZIAKDAGUODWLFTIK",
  "NKJCHRAJQGYMLZIIOR",
  "GFOIAXVJFIHRMEGLLL",
  "WDYCNFFYMMJNNXNZVC",
  "YXQAEZBIDJDMGCIILP",
  "NQRVTWYUGFKQNORLUI",
  "UQBPYDVTJSHZNYYZAQ",
  "WTJBXHDNJLEVFOWZJU",
  "OGKBEOVVSTTLPFXBHW",
  "TMWPQEZQJIGRDUSVZY",
  "GALMNFMMPLKXAVBTFP",
  "IOGMXJCIKGIHJXKFEF",
  "DUNMXTDSFAACQRRBWU",
  "KCESFAXVCWZUUJIUWN",
  "DCHGEHYGSKTQFVJZDE",
  "YVVMIOJFAFVYHDAQEI",
  "KAACFRGXINBNPFRCYW",
  "PCMFYDOHGZNZULRKCY",
  "TRAWKJFWLAXODMGICE",
  "LVCDDRVCCSISHISJWM",
  "USEHLXGJOGHVQNDOUC",
  "SIWGLEMSMSITCMAZPU",
  "DDXSYMPHKHWWIIKQGS",
  "YDHXJYGYZYSSHHYDHU",
  "YUORVPMSTQOMXGHCBA",
  "ZBGJTHHLXCVWJJZMBD",
  "SSWMHNQSSCKJTADRFQ",
  "BJWDDBTCCEEYSMJEDU",
  "KKMHOIDMEQBCRNPNXW",
  "RKIZCILZYYPVUTOGAD",
  "SMMTMSBWPIYJHLQZUP",
  "OCUWEGCSZVGFADSZVA",
  "RJDQZKZLOGUDNQVLUU",
  "RYYWXRBFDIVGUUNXAY",
  "AAVALWDDICCRKUIHZV",
  "ABQQSYKWCODHHBBLJF",
  "ZUKOPFLUVKWOZDINFI",
  "TUUNPTCURGOBIEGMOS",
  "IKHMCTKOBEKFNAPPOJ",
  "PQJAOHSISDXKZQXEPH",
  "ANOQAHAGGOEGRPGTWB",
  "LGAODVHKDPTEJZNEKK",
  "PEWJKVYILGMUSBQQBI",
  "CKXRWCZHCTIQMNYLLM",
  "FWXSHOSVWAPWDFJABW",
  "BVGSRXNWWZDSSZVIQK",
  "IUTNCEZGWJSWYHSYSX",
  "VGTWJEGYIZZAYBWDQQ",
  "JZDSFLLPUDHOSNOOIN",
  "SCRDQSHBEGMWCOLWVW",
  "NLDOZZBSYXCOXWFRNA",
  "RAAGYWEYJMUYHTYUKE",
  "NDXUPMLRFIADUBOVEX",
  "OLRMQHBUTGVWKYMDMD",
  "FVWABBSAVJXSSUQSLW",
  "WXQEVVWEGXSYAZBLPQ",
  "HGEHKPWWVBLMPAKSKR",
  "WQALFWCDCLUUICHDKM",
  "WXQYAXTMPQJRGAVPIZ",
  "DVSDJXAMWOUOYZEJGK",
  "WAZPOEVTNHVNIJSRMP",
  "XQGNSYYOINORVHWJJU",
  "JVJXFFVLHBHPDEMDLH",
  "MEAJFMIHRVPVLXJAXH",
  "LRFMJTCGNPFFMKHOOG",
  "QZKUNLSILEGRXFILMD",
  "WRAHHIIYRYANKMFKNB",
  "BFAYTILEIVCUYFUSHZ",
  "CNGQJWWTAHWHTUVXRZ",
  "KEBTBDVYJNEBMFCCXF",
  "AIZOXEUICYYPTUEJCA",
  "YMZEQRHICQCAJXTGAK",
  "HDWQZTCFOHKGQFLCPM",
  "DBTWTCIBEXZRQCVNFF",
  "BITIQPOUUFHWLVPKNM",
  "VRMXNNOQKCGRFFIMRY",
  "QPXYNFLHKTYOTKUWPE",
  "VFXXZHYTFPFUWRHNBX",
  "GVFVVOVQCQTPLTOITI",
  "CJTEJONXXPSBRLMJLV",
  "IQMVNIZHOFHBKRMFEC",
  "JSIVQYZPVQBUOKDEXJ",
  "SUPPLQYFLBMFIWZORE",
  "GUWRSXUDQKHSNQVQZJ",
  "NJJTRPTLVRECQYHVYN",
  "MTGCYWSTBDPVCCSFFH",
  "MJCPOUWPPDXBHZHLVT",
  "JJDNNQTHBVQRQBQDFT",
  "PQCXMHLFAZVSMABLRB",
  "KFZPEOCKCQWTYBHQIT",
  "CIPBZVKAEDUBVCRZNU",
  "RQVGPTLRDPWBYFVERS",
  "EWCPJJXHJNLHFAIDOU",
  "MLUMXMLSCDFVJWJMDO",
  "IUMJDMEWUXBQTYYRYV",
  "EQFAXEHDYXIMHZVXUP",
  "DAGHYGUHBYFVTRGBVW",
  "WMYISSCZCEWGNPGPAN",
  "ZHBNHZACYOREOBDPZL",
  "VIFCTBAUGEKZUENIXO",
  "AZHBKQBTQRDOJLLIEU",
  "RTUCDAQPWYGUNLEHKB",
  "ROBNSFCGQLQBXCYZNT",
  "HKQXUIFSRUKWECSVGS",
  "OXVKXPKXVRXSMXWHHO",
  "HJFVJBQPEZUZSOKIEY",
  "JSIBEDCRTUUHVEIZIB",
  "RHBYDPTUGDJUSKPBYD",
  "DHIPJRCCZDBKGSIFNQ",
  "MTFLNDZGUNGFVSJSLX",
  "HHDTXFOJJVKUBWCTPQ",
  "QFUBFRRQRSXHBZAUTM",
  "FFFDGIRJQQEGPBJEZY",
  "IZAENLVNFOCOSUTQDD",
  "UQVOFTCOYPPLKPWEHL",
  "BIPDVZOCPAEHHQKSXE",
  "MOXWBVGECFEIDSNNTE",
  "WOJOXCVGMSGTQWHQIN",
  "HYKVSJKBTTSCEHPBAV",
  "RXUCDAVKTJUKYYAGKB",
  "MNGLXYPRYFPPFOWHZB",
  "BZEKFBTJSDBMPPJQXZ",
  "JLVUZGFUASTQMPNVNR",
  "YSNOATBEPDQQLZAKCV",
  "BSIMNWZPGDBDHIWVSE",
  "RCROKIRNDDUZZXHTLB",
  "FJYBBIEPMQYLKZYQPT",
  "TGFRCVXCZTSOQIVFYJ",
  "ZRXYWAGREIFOZIPFPU",
  "UXTNKFEGKNCMTCXVFJ",
  "MRATDOZHATCBEMQZRA",
  "LQHWMXYLILGINQHQUR",
  "VWCXHCQJCDIXSWCOIE",
  "TAVWYJINTWIDHMGHJB",
  "JUVWFVEWQDPPBHNKNQ",
  "PIFLMGEETTJMMTRNKO",
  "BNYMTMKODWZTIKUNSE",
  "IGZGTNYKOSJSFINDOT",
  "FAWKZUUDUVNLTSAEEF",
  "WDKWEEVSADOHIVGYWY",
  "JQJJPIEGNVAEHYCRLL",
  "JBYECSWRWJTELNEXSX",
  "XMREXJXRJRSYNKDNCZ",
  "GZKWQGUXZQJSJAZRCZ",
  "ZOGOBTMQVVALNSZULB",
  "VVSOCSJMQGELWOGTQH",
  "GQVJYZRUZEYDLOPRHC",
  "SJJUTVBFZUJJGXOHJR",
  "PQDZFNCTZAFDHFXHKE",
  "NFKEWMPVJXBGQAHPUW",
  "JRHGOOMFRKWRDPWNMI",
  "XWQFVXFYQHCJNBGMHN",
  "RRPCTPVSFXFNZUPQLW",
  "RPRNJLEMCRSEPKEVGD",
  "RGZPTDURDPKFFSPOWQ",
  "PNBSXZITTOORQXSEKL",
  "JRFLLMSFNEKGGVCZWE",
  "HRCTSEOVGJDYAADGHZ",
  "ZSARNNLDVRRFHNRBKJ",
  "FAXRZBSXQTDYROMQIN",
  "HMSJMTRFZUYRFCCVVK",
  "UQOYAAEGSQGOJPHTLO",
  "GPFZUWPVOZLUBOYGEY",
  "AEJPBQPUFMZVOZDXQX",
  "JQEMMDBMXZLHWITPKV",
  "NZAMKCKWSNBLHRSHTY",
  "GIQLEGRAJWCJLYNETO",
  "JDKLRFPMMJDXOSJHHP",
  "DONQKMFRPSMHVEQBDO",
  "TXODRTFHVJQAYRDUDI",
  "FDUGBLXFRVFXCAHNEZ",
  "UWKJJCTQDWRBSYWJYS",
  "UYIPCZXTNIOAFKEBZO",
  "QKQHTZAOCLGOSDVEII",
  "RRIJTCYMXULMCRMYSN",
  "WQNZYURDUTKALNJBSC",
  "IMXCOUZGWWUENHLTXU",
  "UORCSEPXCTXIFBZVOQ",
  "GCFDRPRLBISCVWSYSM",
  "FETDXPOSRSNIETHSNW",
  "KHCOBWFXMIUQXOAEND",
  "PEWFGKVDRNHGZHJFBF",
  "VDPSGRHITGIPLDBMKK",
  "HQVULRXQUCPONGPCGX",
  "UYXPTHZRRJZBCNEZKF",
  "HBWSKTNJBAODRQSKEM",
  "OPLPGMVKJSKWVAFFEC",
  "SUQXXAMRCCKLATWSYS",
  "SOVFKARCKTCHFZHPOL",
  "YVPVIOFJZFZXQUSEKY",
  "ZEPJEVTZEFRJBSTIDW",
  "FKIZZJVFDFATJESBQC",
  "KJNVGGOASLQSDRRDST",
  "SHOPNQVMHYTRWZMDCN",
  "LIIJNXAQOVHGMHJRVY",
  "FSCVLBUGZPCAYXCRJE",
  "TNGBYICFOXFARUKKPP",
  "QBRKCSGNVJBRYJGXNM",
  "FDEQSULCJUTGNOCZAT",
  "TMOITDZKMCHFEOZHAR",
  "GOYLAKGAIPMMQUEGRL",
  "HWLTKRNYMGCBAVKXQA",
  "NHKZOKBRFVBYSCHMFS",
  "QVMGVFRGYMZQOUFXLK",
  "NARYCMIWPZPFXRVCRQ",
  "LAHCCQDKYJIEIWOFAT",
  "JTJMTTMBRTZDUZWEXA",
  "SGTYIKJOTVKAEUUDAB",
  "MXQDEOUHREOBLQHWYN",
  "DLZOLVEWNKHNCQWZFG",
  "WETAPFANFZKACYVQVO",
  "ORPCDMKIJVHXRPWDHL",
  "ZXYKYNRSVOMTJFQJIU",
  "ACVHDAMPDQGOOORDZG",
  "GOPOIIIQGUUKWWRALG",
  "ATDIEGYWXJKOUETMKG",
  "YBWAKVGZWNMDPFMTEY",
  "VRDQSCISXUKHGYRJZP",
  "SOLXZJIBSXCINGCIEL",
  "GBSQUOKZNJVMQHEEEP",
  "BUMPKKOFHKWCEAYJQU",
  "UMIOAECPEPIZKLWYLK",
  "BIDZCLQZNZRBTOZUVD",
  "MEUCTSVQVTIAAMHAPE",
  "ASEFJZYHTJSUOACRQC",
  "DFRRWGBXSSYXVZPKRO",
  "SISTSQQYAJISWYCSWM",
  "SOOEHGGKRFFXJMZBWX",
  "FWFQOEGCWOEGHSTSVE",
  "WBRQWITLTXGEXXCZJL",
  "FJLDJPPNQCOZKDTMAS",
  "PQUKJZOVWHQCCNURTA",
  "RESITDJOLYPWIJHBRQ",
  "DPFCCXMRGYKPAKRTQY",
  "ZCAMHZUIUTFLKSUICR",
  "SGVDGIRDORCYSUZSNI",
  "ZJPYQFEJCBVCAEEYOZ",
  "NDQSVPRYWENTHRWRNM",
  "JQTJVTIIMEZYYCBZSG",
  "ORFHQAFUXZSVVPJTPJ",
  "HRKVJDMXRHLXXOMLFA",
  "MTPFNRDVTIDOFNAJNQ",
  "RUJQIWABGWFSYOGUMC",
  "LYMZWLANTKWSOYIYPT",
  "OHISIJCTYBCZRQZOQF",
  "DTTMEZDAAYUNDNSBNC",
  "YQUJKGNFBEPMLBPIFR",
  "EKRZYXMYINCLTRQRXQ",
  "EGNFJUCQVOZVATBKYE",
  "UNKCCSYHCBWCLDJFAC",
  "SVZUBZVMWOECLCYNAP",
  "LUFPKGBDZMBKPNEDQM",
  "JKRANNYDCBZYHVNPNJ",
  "SSMQQUZYGZWJPNVKFA",
  "AIMOLHQYRSEXVBRSFF",
  "TQAJZIIBUDENBPXHCF",
  "CZOHRQVMOXSDAMLXTO",
  "HGOJYXJZZRSUBYCGZQ",
  "QBVHRDTXMLZSLWZUAJ",
  "QMHYMLTCKUNRUFEUQN",
  "BYVASSXNJBHXWGEZGA",
  "GUHZTRCPLMKVENHHEB",
  "TQSXQCQRCIEMTKBECU",
  "OLDVNJGSDHARBRPSEA",
  "ZRSVISIGEVUFVBRQUU",
  "CDSEOAAJMJJUGDHGBU",
  "AZWVJIAQEVODUHNLEG",
  "BRUHRPMBEEWVQWYZHR",
  "XISTGKLWZUFNTDLIIW",
  "FLFQEEIHFZGYZWAGQW",
  "DTJGSKLMOZKURLSUJA",
  "MOOOCRNJNESXFDWQJB",
  "WHNCIYKIIMTHOEDSTG",
  "DWDLSKYSAAUCKEALYT",
  "EGJWMMFOPFOYNKACQZ",
  "JWVXGRXSNQVCDYUZDK",
  "MKCQUATBDLFWIOVZSX",
  "IOYQYITEGFVHZNQQDR",
  "TXNDXOCLDPJJHLEYLC",
  "GIJXFVAFPATHOJPKFD",
  "BYQHPQENYVBOVIYJEH",
  "KZERBJPLUFRFDPUTSF",
  "RQWUTNOILNJFAXGGFP",
  "YAUJZFQEERTXPJPPXO",
  "TPHRFEQOMFNWMNZAPQ",
  "AKFAMTLVPIVLUWVYVK",
  "HGGJKSVJMRQPRHBOZK",
  "JCNMAZTIOFSDDPTEUR",
  "PTJQTYNHXIGXHFYWZZ",
  "AKHYJJXQHBNTBMFFRQ",
  "QSWRMIOEEJZVJEQQMU",
  "MCBNNBGKWINFHTNCUW",
  "CKRMTINFQMGLNJRESU",
  "QJMKYPJZOTFHTFOVZO",
  "BPOGYWAJOMCMQVOQSI",
  "DTNEQDZJRIRHSKAATV",
  "UWUVYBNUBKLRIVQINC",
  "TOBECRJXCMWMASMTGK",
  "QRDWNYBKBPOUVJANBZ",
  "XLHTQFKVHOEHKYEBQZ",
  "KJGDQEAQDFNMUCLIGS",
  "WECFYTCSOWAPMZENEQ",
  "JMZPCAQRQZUTDOKLPS",
  "UMOAPNRUACDXGDMSHG",
  "SQDPHIXWTGYIXMKRWO",
  "ECPQHVZGTTBPFQVWVX",
  "FJTCWYJPRQIJOUUEAK",
  "ZITRKJMZMLTBUFJORX",
  "ZFRGYQXISDOVCPKDKE",
  "ZJXGKXOSAEJSCWRDBT",
  "SWYQYRLOTMUWRSGAVO",
  "XRQSQLEULDCGZQAHHC",
  "MIZBBTXZJDQRWHEAUS",
  "IJAQXZCXZWPONYANOO",
  "KUSSTCVHNOZQEVJKFE",
  "EETRWNBRNKNYFFXRNE",
  "DCRKLUZRKBRMNASOSD",
  "RWOEAYZQHITXZHGUHK",
  "JUYNKIJDLPRTCAEYPL",
  "UJVGEPMNRZMTDKVDYT",
  "XSMQAUTJDHMWQYCSGB",
  "FUDVSDTPJMHCWUCYIY",
  "ZFHXKKGWUPDQNIRPUY",
  "VHIPORKXDXBCGJASSF",
  "KPNVUHXEIZSOZJJTYY",
  "MCGCYHQELLCUJFEKON",
  "PCQPALOGAOFCGSWYVM",
  "DAVGGTMIAWVOFEPSCV",
  "ETXQPALPQZFSMIMFRB",
  "VZRSIHFTPTPZWJKTZS",
  "DVICOOZUWPCGSQYZXM",
  "YXDVGJUEWAHIKYFBTD",
  "BVHORCQXUHKZXJTEOW",
  "XLPVVJOABESKZDPHEW",
  "MRKIDSJLMBLKETXZWJ",
  "XOQEMXCESYRVPASKHB",
  "WTJKKEQNUVXSSGBQDR",
  "AOUCCLBJIFHWFQVHUX",
  "BYJBFGTHHQCGRCCXRZ",
  "AMZEUFHXPITZCCIXXB",
  "IVDOTIBVALEDUDNUGA",
  "LRBIBPRWXYQRKTZUMN",
  "XBQGHCNFZNIYCGTXTQ",
  "EOVEFBCCUFRMMJAAUH",
  "ATTNDIEKRJOFMOQNGS",
  "GIBHRTSYEICCKFGTRD",
  "BEZFDWTPLDBJZCCYVD",
  "FUNJYDICVKLNXRRZNW",
  "WQEQFKZHHYHFWCHYGD",
  "AUGNIZNUZLWAKQUQER",
  "NFARTYVMULGLFBZNGZ",
  "WJUQAFHWGYKYXDKJJC",
  "MJBPKVLWMWHMWYRSDJ",
  "WZQDGJFSDCNPOOVDRK",
  "DSYIZATVMMMPEYGXHX",
  "AFXIRHBSHIEGCXHJWJ",
  "KPQZJOZVCARIIUQCWQ",
  "MDRDIHFKANKPDUYMNC",
  "NBRXDDBYHPRNVCSZUR",
  "QYJTHPZBFXZQUYOAXF",
  "UBOTJRXDPDRXZCNPVD",
  "GEIMXYDCYHESCMZOVX",
  "NNBTUFJEQEYQTPHPBS",
  "VAGDMMELUVISCOXSJU",
  "KUBMUTPSEZDDRGJBBN",
  "RYKYPAQSTTDRAPILGD",
  "BHPQKSCQLEEUOIBRMM",
  "GNPLBBPEYJITDZJLQX",
  "RWPESVTJSTYRNIULON",
  "KWNDKCASOYZTRDVKVP",
  "CSORWAXXMSLSJYRTUM",
  "UYVLOQMZELMJSNEVGX",
  "ZMXHBXIFNLOGABSQXO",
  "PYVITDIUMSKFREVGTG",
  "IHTZEFOWGJPQNPAHIL",
  "DFCCIXCBEWGMLWSWWS",
  "DMJWKZFFOOLWROUALS",
  "INQZTYDEMJUXCLZNBR",
  "CDSMAEIKVFQBGWOPBD",
  "YTQTDUVBJWZRNEFOXI",
  "IQPBEVBQRFPADPGWUG",
  "CQGELDUPURDIBNSHIX",
  "WFUQIRCORTDKVNGTGU",
  "FMBQHWZIVLBGEBNAPK",
  "VNOXMFNVBVJJLABPZD",
  "JJLLSKYWLUTUOQLJFH",
  "RHMJEXUBLAYFJGRONM",
  "RNBTUPAWAZYALRSRBS",
  "ICUMSPNJLNUOTXWPMK",
  "DJAXZMUSGHTTQBMSKO",
  "MHOWGUZFVLQBDUSNCE",
  "APVSNCMQXQMUEPMOOG",
  "IYIEVHADCZMXTOBRPL",
  "WSKWBPLYRMKNGFDXON",
  "ZXFSZCXOMGIAJCMQMX",
  "PVOFQXPARWKPWSCMEU",
  "KOFIRRGLBQDCJXYKPJ",
  "PPEGDFQJQJSXIEELOU",
  "ARHSFXSRWCRYBMUAHP",
  "YJWSBEZACPUFOVCCEG",
  "BVQDYSZGZDANWJUMRB",
  "XRCPLAGAOJFGMJAFKU",
  "TMJLGZCHXKFEUXWKFZ",
  "NCSVKRSCRRQMYOKIAG",
  "GIHUMAEYVLGOFFYKVK",
  "DEJTIITCZEZHMYSSHR",
  "ZARRUCTJCJYYIYZZDO",
  "BTDFHJSZLUKRINLZDT",
  "VLFQRDHREKTYZVICNE",
  "VXDGDKLVPHLQKNWCHW",
  "JSSDJEGDJZZYVTLNUH",
  "KMHSBAIQZVYWOPUTGI",
  "VELPFHJNJTXMIXKOCS",
  "WMXVMQNCCXKRQBJETQ",
  "EVVPLGVVDZVOJTYEXJ",
  "AWVZRUSDWJDPOSPRXA",
  "HATDXNHKDRTPFVLZYO",
  "QFZIWBGVKAHMMGNLZG",
  "ZCWLXIIZTSFPSETWNL",
  "TKXBZPINNWQOWZNWSW",
  "ZFRPDWKGXOQAFVVTXX",
  "YVIYQZNJVABTAPPRGB",
  "QLXNCYLSLBDGJQSZKL",
  "CEFZHRNDLARLUOIQTV",
  "FQXVONPQJTCYQKMRUQ",
  "WYEATFXXPTMOIAHNYE",
  "YBUHZCSPWTHFDIHNOJ",
  "FHTVETKCSOSODDOUCW",
  "DQOVMAADAEOMSYZMTA",
  "YHFNGOVEEUMETBLYEB",
  "UASPVAXPYLMOCENKYO",
  "DECJIZNOERXIFWZMCH",
  "JRVPPDNUJAFLURHPRG",
  "XGOZYREBOMHJCNOBUL",
  "FZQFDTWWZHLYAPIYVC",
  "NQMJEXPFMLBNXBCVBZ",
  "IPLEOREDGAHQUGSTFL",
  "BUMQADCMSFNNORRIML",
  "SWJBUSPUDNCBMLWIIK",
  "ZVSBMEUCKUOJGPAFDK",
  "YIONVGAJSWEBYUZBXG",
  "OMHDNNUDCMMXGGNQZZ",
  "QVVMHXEDAFVLLDIJXA",
  "DLSBUZTNBVQWPOGSCS",
  "CIXCJNRVMRRLZDEACO",
  "JVEZTPDSZYQRORIZXY",
  "XLBKPWRNCDSHZVMFAK",
  "VNRAQKIJAESVGQZHKG",
  "NWEPSKQNTCIIMSPJBF",
  "KWXNEZOIXIOQICRLZH",
  "IMPHCMEYDKVGSKWEUA",
  "MGIDAFKJROQGPQIRHQ",
  "IEKKQCLBKBTWYNBKZJ",
  "KXATMDALPLHLWWTELX",
  "GGYXZQLPIJGBBWAKXF",
  "LXURIIAFWOCZZZHCXT",
  "JJJFCAMLTBZKFIHGPD",
  "HLIFQNCJVWGPKTVHXF",
  "EBMLQEJGCNAPVOCZOJ",
  "CULXCVYGFHSLQNKICK",
  "XQHQECTONQSBCOGTKS",
  "UJRPTYTQVPZQNRJFJO",
  "CWWYSQWRBTYYHBRXLC",
  "HQUCZXJVUKBHVIRDUY",
  "RSZJHLGQYZOPXBLUHM",
  "OVGTUWLVHNYQFDVMPA",
  "ZZGSXHOUTIDBJZSNRL",
  "XVWGJOQJLZOASMJVPX",
  "XADJRVAMOTSMLCPLAG",
  "GUBWACHIFYIQTAZBZV",
  "HHZNPJMFSNIGHVLVVJ",
  "MOOAUXSKDWELFTQVAQ",
  "ZDAHJIMEITLXRMOEPI",
  "PHJRLGKKWLBYGJZPPE",
  "JYIVQKKMNCCLAGWMXE",
  "YBTZGDBMWUPLJRXKRS",
  "CHUOXZCJYDGGPCBNAA",
  "RHOFEGUIUYFUXHUTCJ",
  "SDALQPNCKGLQMRIOVK",
  "CZVVZUOYKMMASGFAOV",
  "ZJJLOWSHTVBJDXYSGJ",
  "EKHJGIEPLLOUTNBQUK",
  "YKPQOPINYYKZFKPXJA",
  "SQFLVWQAQUFYMHIOFS",
  "JJCWFDHNVBUWBZARLV",
  "ZHOPMSKRHTRSTKIOEL",
  "HPDXRTOTLFEJTCJQDD",
  "JHESWYQNTPXDPBMMFF",
  "HSZYVFRXOJTTNKRCAT",
  "XYVVYBWIQKEQNPVQHM",
  "NELUGISBQULRBWOYAI",
  "YZOINPGNWVOXJBARUP",
  "UWJBALUOYLZEOTWXBP",
  "MHTAWOARNGQDDXIPYK",
  "LXANWKGRPRDSZBABIH",
  "LMUEUCWQDOQOTVDOBR",
  "LMSSBJXCOAOLUOKCFB",
  "NHJGSQAGNKYGHOVIAA",
  "LZOEZXLIQHQSJVLADI",
  "SRCLJFUGCZSGNJREIT",
  "TMWJYVAEUUSOOACTJM",
  "YHKMQSCBODPFHQGFKA",
  "POULJZWUKQWLODVFAR",
  "CAPEYGXDNYJTSVVRFJ",
  "DTGFCNKDJTQTECLZRW",
  "YZGDLUREOFRRKRIZAJ",
  "RQCDWFUNXYBWFPYBMI",
  "MJHGOIHDFAPQHHBJIZ",
  "ZKKJCIXKEKUTEEYBKD",
  "NRRPIWPHMUVRLLKUWV",
  "NXWVJDFOGJZORGKYNY",
  "DVFLQKFRUAEPAVECMB",
  "YZWWEKOVBCILZGCBJE",
  "OAASJJKUGDUYYEEKPL",
  "OKDMNYQBMCSHRAUVWK",
  "WUONCFFHDXHWZMLICP",
  "BIDNFTNQBJZVXCHVIR",
  "AEMFNYQQVZJWGVKGUZ",
  "SDYNVHCOFGJTNKHLVC",
  "TWXBUOVKINTUFNPPHM",
  "RSDOWTHSEUWIKXISPW",
  "DVVHPXABFUDGNXCFVN",
  "RTCIXJZMIOGXLLILPJ",
  "PAEUWQEELNEZGDLHIQ",
  "HBXKRXWOFJAQNAAIGL",
  "IFZJRIYSDQXDCVTLOX",
  "PXOYCLWQPADRQTEGTE",
  "RVVBXGKLQEFAHWVRME",
  "QIPAWQJUSWUZFYYGDX",
  "IHJWSRGNQVIGRIZHPM",
  "CDXMBJPDYMQZEYOXRN",
  "ERQPHJSIMIUMJBRLXQ",
  "DAGWSBTORAIKKPPRVF",
  "WZFLUIMSDNFJJRCTEE",
  "SXDSBRPGOFCLCWHIQV",
  "EKXPCSCGICWEQMPJJZ",
  "JBXYMXCXXSGDPHWQBM",
  "CODHHKMBMRWATWSEDH",
  "XSUZRNQQGWSVBCWBHR",
  "NACVLUXGTRUWOHRWVD",
  "TXDMRFLNMWAXFAXOBN",
  "NGGPTHIVTEPYZTBVVL",
  "DBYDCPVPWBQEFVPGCT",
  "OYQCEXYFJGNBCEZQPZ",
  "SEAMKHJRAUCPTGEDIY",
  "YKYRNNKZNYCRQJNCXO",
  "CHSZIUNEFHBGXRLFRW",
  "OFMZECIXCPDWLYIPSD",
  "XTQFBPBHTYYMVCVDWA",
  "ISVIBPVOBBNQQNRDNQ",
  "LHYKAXUMWYTWIASAUH",
  "HTGYQEKNUJSAPRFXWR",
  "LWDAYKCCRPOFQSBHXQ",
  "SCNCESHAHEOTBDGWSR",
  "XRPAFYRKRCXUMZFTBY",
  "JHATDFKTJJSJAITBPA",
  "QZSASBZEEPTNPIKKEN",
  "EATWHUGDBVZSKQLOPD",
  "DMIEWBYSFNPVQTYLTA",
  "PYNEUIQTYXAQIKYNCW",
  "EMFJFPKUJAJZAOSKHC",
  "NRRIJVAAWXXAYZCGQM",
  "YJGZALCPKVSIKGLXQC",
  "PAZPAJJOMDJZCFQESK",
  "FIKXBUNJSGKRUFWEWQ",
  "VSANKYOZWVSEMGWAXC",
  "EWMEBFAMQUMYUKAAHT",
  "HCHFZLUNWEFGEQCWWN",
  "RWAMSTEWMJUUDVALXW",
  "RCHJOLRSGVTZNVLIXG",
  "LKCVNHHLKJOSJRXIAH",
  "PSZPBDIXWARTDCZIRW",
  "KOWKSVEJOIEAZWQPVU",
  "DIFAFCSIZYNWIZWWHE",
  "ORLMYJFNEUJTKIZQUO",
  "BVABDPKOWNRZTIIHKS",
  "UJNRGRWMJHTRHZNEKO",
  "NEBAVGFEDOUAQLMAPK",
  "ERJBKLBXHIARLITJZK",
  "MJPHYUFNUTTYEMUJOW",
  "UWHGQZCSFBJVVCGMZO",
  "VXSAYGRMRKORFJMWJN",
  "DLDXFNJRDTDHVAWWLJ",
  "EJGZUMJGYWXDRKACCU",
  "CCVPHLEMFMTKRDVJGB",
  "HGDMVDTYMPINKSESBY",
  "ORSCHPWKQZGTYNRQMP",
  "UXZQJBKXMIKJGSLVNJ",
  "QHHKRINGSXMTQTDGPO",
  "TARFVKQDRTYGKVMLIP",
  "KURXOBZLAWSXEONFQP",
  "NIDJPDJGWFRMWHCOLS",
  "YHZXUFPSQMRFXQBWYJ",
  "QEFBLRGANTWTCFQWZM",
  "ARZRGYELEDZEIDTQWI",
  "TPKOSAAKYRRXJDGRQC",
  "ZNVXGHBULEDOWJATAX",
  "ORJPVCLDTYSFBTSNDI",
  "KDWOGAZFKJDVLOWYVI",
  "SWNNZCWXYQGTEGYSEH",
  "WZOYQORHCQOQANCHXM",
  "JKYGGBXAACSVRZTTLR",
  "NZXSLIUPJRFDTXEDCC",
  "WUMLEFCWREENFXMPZU",
  "UJQYVYYUIQLDZPBTJE",
  "CUURKFNEIZJDYDPNRT",
  "CHOURAMGHLFTWRPMDV",
  "ENDBLDCAOBHIFZRUAA",
  "UHFEMYDBMZYPVAWMMN",
  "SPTZBWDEWNUNXYMVMD",
  "ZFONJDKYIBALFQUBHG",
  "DOWKTNYHCHMWKIVQGO",
  "UNIZBARIDVTXQHEZTF",
  "HURJNPECQHHXFOWNRY",
  "ZVJLOFQODQHWFHNLVY",
  "CCMTYMVUVVGGXHJBSB",
  "IIJLGCRADPMIHOIERA",
  "YCAQNJMFLCPCJMTSYP",
  "AXXEREXHQTGQHWAZFP",
  "YGRPUKRBTONWDHOWKY",
  "JFNUUIPEXQUVGFDPFG",
  "WZEUNCDRJGFXRLIBXF",
  "YZQIWJJOEHDFMHTMHS",
  "FFPBDZUKJSKAEGGJAF",
  "YTZRLXDSOFHZIDCZBG",
  "NRSYRKJBSVCXINYGHU",
  "ZFFGHQDNJDJQDELZML",
  "GPBGFLICQOXBSLMLJI",
  "NHIHTZRDBPDNVXQDSP",
  "DTRLBGKZLBCLUNVRYK",
  "KYGZAWOPSXOPNVSMWH",
  "UXJFFUKFARAVQGXJSJ",
  "CNHLXXAWITTOOGWXZR",
  "EVNFAKXDASQNTUQUSI",
  "AUQXYCXXTGFWLVTZCP",
  "AAREWWAPFYBRVSNXOT",
  "RSZTNDDNVAULCOHLTT",
  "KTQFLKQVTSYIKWSOQB",
  "BXLGRRGGIKBOSWJHTE",
  "XQEGWLBKSQOTQZYELK",
  "XQTAXFCQBZGGFWGORS",
  "HVSEAZCEEJFWNSJKUM",
  "RBYUGGXWHDLNCSJOPC",
  "YOCDNUCKWIBSUSXRAP",
  "FNXFUDASVXSZGPWWTU",
  "ZHGSBBSYGTCYDKFJPE",
  "MILJIWACGUUGQAUKHQ",
  "KAWTTPMADDPXRRNZBQ",
  "QMUQAPDYGZUJXSOVDW",
  "NWZELQHNRJTYEZVZZH",
  "MQAJYXMUIUTGXOULRI",
  "CFVYKEMNGZPBIUWNPY",
  "VKBSYCVMMZQARXGVKW",
  "QAOJYNDSDOVMRIAFNG",
  "XGKUEZNKRJYYDJBEJB",
  "DVZVQGKLPLMSGVSBEU",
  "UIGCAEOZVIMPLBDTHS",
  "BZNPRUUMLHFLJIMVBV",
  "GLCOOSHVBITXDCXPTH",
  "DTCFVZAJANHKIDHOZC",
  "UACTAHWCWFTQACHAOH",
  "BIPGTWFYESUDWNYYTU",
  "OSCQLDOBIMPVRGBUKC",
  "LRCDAKWMHUFFJFWETB",
  "PGYJHRCQOZDKADYUMI",
  "ILKUQYEJHGUQNPBRHT",
  "GPBGJFLMCNATFKDRUD",
  "TUPZGAAZXXLXLMHUMD",
  "CFYTLKZWVAOOHFBGMS",
  "EPTVNEMLVOVBGLJYFS",
  "DQTGPYEUKODHWPMBDL",
  "BSZGULRUUCOJNXAIWW",
  "UFBIISWBOLZWDJYBXE",
  "HHKMMCQPUDESYQTXAC",
  "XTOFUWTDUPONZBSKWO",
  "BRQOSQAWLDBEILGVWA",
  "GRCXPOPZRDJEWKDMDU",
  "VPPAOESUJTVWQQQJUG",
  "ZIFFOLUCNSHQLGASCW",
  "WKSWSSVLJCUXCMRDXC",
  "DYVLGZADRFRBZPRKWW",
  "IUFNOGVVAXPUCLQVRF",
  "FZOWONXXNCYYFAZOVK",
  "LRGGWUEXXLBFVYTSUK",
  "HMVTDBVAMVVNLYTCDF",
  "QONQBFOAGTXUSQHERI",
  "ZYGKGPIONHFZDMAUSJ",
  "HICSCWBKCFPGWTAXDD",
  "GYOWKDNRJKGGIEWNBW",
  "JTSESKARJPWXUBWLQZ",
  "KDITEONUFFKYRKAZFL",
  "EBJTZYBKBVFXNZXRDG",
  "TPEUSCVLZBIOFHIRQZ",
  "TFGTZJPRRGSSBPFATU",
  "OOPBDTRIHSOZKGFUHZ",
  "MWAAYDFURLJVZMXZYH",
  "PKMPHHQYDOGPEVBJCI",
  "WEYIGUZNDZVRICXJBY",
  "JEDFKYSUWHRGBRRNSV",
  "CTAZTCNKKRSXBSIJLM",
  "JEQSEJKBDGUSIMACYK",
  "QJOZAQBYZGUSETHNPW",
  "YJAXEZLDFLNWRRCCDG",
  "BMPOCRTTAJNESMMPUD",
  "PHZYLLOAINNNBZZKXB",
  "NRHXFVENODXKGEBMEX",
  "WRIWDZVJSNBCHXFIUY",
  "JVRAWGNWOVXBGZDMJC",
  "KWTSWNRGFYNXPHVBQQ",
  "MRHJKORRSKWQSVSJSR",
  "MDHZHMURGOMBRXIFIG",
  "MZDYWISOEHDLISLKXG",
  "SRHIFPHHXXPZDYZXRL",
  "QHHGKWLYGYZDCNSGMV",
  "THVTCDVRHPNURFZPUL",
  "IERZXMLOIDMAYYKQPN",
  "QYUSSEZTYNOIZFCNEW",
  "ETTXYTAOLNBZUPHCWX",
  "PTYCTGJEMHRRDYNXBT",
  "ISMZHNDIHAXWOVFSGZ",
  "ZIIDBUGNLFNYPQOFOH",
  "OLICSJOYIGPRCTZWKR",
  "AHMPVYKCHFYPGHTWEQ",
  "UQTPSNEWRKTCXEKDGB",
  "MFXQMEVPYMJBKMBTMA",
  "JECFMDYGFXDZWAFQCU",
  "TYORWKDFCATYJGMGBS",
  "KQXRWZDNRUBCZFHCRK",
  "UDXUGYQBZEFUDCXSXG",
  "SYYHUNSEFLBJPVTHBK",
  "PKXKKQZOFSHPCWALET",
  "GNXZJBTKSFBJGVVCPG",
  "NNXPYINYAVOENTZQMV",
  "CYDBVHPABURFGDHWAN",
  "YBVEEONXCUOLXYTFSW",
  "ENFMIDPPKEBYMQUUSR",
  "TJYBRKZPGEUJPCMADF",
  "FAJMRPRSZRWEOZKKPJ",
  "CKWYDAMFQXWRFMWSOF",
  "FQBDKGFNHWZHVQEPEF",
  "YMMBOESAVHPBBYEQSK",
  "ZYKRYVTFFCROGFZICS",
  "MIDUPSSXDDGMEVANXA",
  "DDXDMHJKQKPLNGSCZJ",
  "JWOFMQLCVVFKFSCSTW",
  "MYSUPMKCCORAIHYAAA",
  "UAODWCFGXIZHGMXWMU",
  "WHRAPNXQLFDAOBQLRX",
  "GEBWTUAMQLMNDJNEXI",
  "MXVYBPRAHMKUOQLHYW",
  "AKMNJIYKTZORBZMVAI",
  "QPNSCHKBUBHODZSOUW",
  "OLHWPRHIBEUKJFACQI",
  "BANHWRFPSFRKQSIFQM",
  "XQTJWYJHUGBFKNPGFK",
  "ANOHSRVPIHPBETFUYF",
  "SEVTIMPAHBVBMYUGWB",
  "PQDHGFPSYNDBZMQGVJ",
  "OCNWPJLUDRMHZZIYJL",
  "TEDYAHCLHAETESYEPQ",
  "XFJUEAKMUEKOWLDBDP",
  "MRSBPSGEEGOHJRHFRV",
  "OUZUTCFMBVEDXMDQHI",
  "XZBAWVCKLLADJIADGQ",
  "YGUBDQHMQNMUEPBASC",
  "EBPGNJCXBHRZJWDKFZ",
  "AEMXEQFUGFPHRIJNMS",
  "EGWJNLWQXITJKYBEGH",
  "TJZCFAPNGTAIUDJEJC",
  "WXXCWZGTLOIIAHXSCF",
  "BIKKNGFWOIQYIVHCSQ",
  "IZWKCNTQYFMYUCSULS",
  "WKNQGYKRSEDORXHDFG",
  "SKREODTIUSRSIRSEDW",
  "QVXQZXBJWOPBZYXMII",
  "YKPVTFNTKYYEFBDMXP",
  "ANWDEWPQGBCTUSWESL",
  "FFYFZDRWZUPNMPDUAQ",
  "BMWAXZQJQRPSTGNYDT",
  "HYLVAJBBEKFETVQLIU",
  "ESRTLURHWETQAXSZOS",
  "JVCHHFODESKKJYJMAJ",
  "MFXYZZTUCRYBUOPUWV",
  "YZUUGJNUPKUBQBLZDO",
  "QIJYYAXYASQEZBXFWQ",
  "KCXGFHJBRKFQVUWWIB",
  "CVYQSXCCUUJOLYNEYD",
  "HRFGIQCIZKOCYJTYTE",
  "IEOQRCOHRLDMIQCDFJ",
  "GNUWRJFKYXKHSMYDPZ",
  "FXBFDJEYJWOEOBYTPG",
  "TYBYFXZAQQMMWDXMON",
  "AMZIRUVRYYJRMSLKAX",
  "PTBZDTWLQJVEPGHXWB",
  "AUJPYIDSUEBOPSOHJW",
  "LOFFGPUYISSEJGSRMZ",
  "PNEHJGUTAQPYFOSZUI",
  "AUSFLDALOZCXZPHCKZ",
  "LRUHHKGDFWDTTEYQZV",
  "CNCXEBFJKQMJPAKOQB",
  "ZBMVLEVCFWGSCDGUJH",
  "TCEVIXQLSMUVJSVJFP",
  "TRDFJOZDWMNXVZRPTS",
  "VIVAQVJYYHZNGXBQXM",
  "EILRPKRUWSAYAVEQWA",
  "XYKYWRCQHARTZHJKAY",
  "SNUKLQTHSMYWIONIYX",
  "PYOTSFFJLRIUBLWEKW",
  "YCTARMGOUXXRBNEXVV",
  "PFJRJMQKNYRJGBUAMI",
  "AWJBHIQVPDNBBVKJDT",
  "WZXFVHLIYCGMORSGNP",
  "UIHZSOCMRNGUJLRGWU",
  "PRKXBVLLZKNPJAYJWD",
  "IGGUMTLKWCBUUEZHJX",
  "NSGHWQOHEAGCCVGBIA",
  "BGTTYQOSQMJNWIAYLC",
  "WLYWEXRQZHLOOFRDTD",
  "KRSZHEEFYJBHCJZBOJ",
  "RCMQWLUSPAUYSBUZEN",
  "QXHEFLSRUJHHCWZBEI",
  "TTXHEPGRFZGQLLNNLN",
  "JCERNTRZSHSGCRSTOR",
  "AMXLOVRILDXGWZSVCY",
  "PQQCEUPEJHLEAIIPUH",
  "HKEKKBFORHTKLDJOUT",
  "LZBWOIQSNLSRRJLKXN",
  "ZSLKCRIFAGNWOQQARI",
  "MKWWYACIEVLDHTBFRG",
  "KUCTAWSQGIQELPTZOI",
  "YBSQQRZQCYIKWCRHTB",
  "INONVKZGWQYRGSAOLC",
  "DIJQLSHEMKXNRMQIQQ",
  "QEEOSHXNXSBJGYCYKZ",
  "QWMOHMXZKVKTNPPSPH",
  "QXNTPXNOLHNBCQICQN",
  "RDGQMVLSORWJZXRYXA",
  "KYHZQCHLMNBSRINFTH",
  "PMGPAJVVHAVKKETUSO",
  "DCUZPFZOOKXVJRBNFY",
  "KPMPOCFUHUBWYEZPGM",
  "YTNFGJPAXQUORXQGTN",
  "RJIZTUYYGEHMDAFIKP",
  "SVZXGLTJDJIKHICGCI",
  "KDGGRAARUIBTZCKPJR",
  "ODMPJHKCJNJLHTXVQL",
  "FBAMOORBLHSQXCLWLX",
  "XJKEJZQUSOSGIHVAYO",
  "GYJSGCOPWFRPEEWWTG",
  "RBOJPVKUUNMBNWHHXQ",
  "KYBGHXNNQLYMDOOSTK",
  "ZSLVORCDQVBTHXRTAR",
  "BNPHVEGZOHYDHCENQR",
  "YYZOZIICDZEYYWGCEP",
  "DHYJKWRLXBWHFIBUNJ",
  "VHHRUDFVTVCDLUZKWZ",
  "GYVXSGJPFVVOPKEOBG",
  "ASPVKRBXXUMADNKTJX",
  "DCGDJYKDINPLHKQBDE",
  "NTHYSBKELABXTZHCLA",
  "ZLTQUINXQZGTSOAWIJ",
  "CAPXATZFVYRMIQQXLB",
  "WOUHNCVBRUGGMYSGDW",
  "XRXRWWRGILEPPDZHWN",
  "TXIWBOFLPHCXRJYCHK",
  "DOTQEVGKFPNWOGAOQN",
  "MUBRNYNLDVWCXWHPOX",
  "SKJSTJYRALHORTXUGX",
  "DXXLQNPMOSCSDYBLUH",
  "ZMCOHXAIVMYJSYRVRM",
  "JQJSMFUARXFTXSOUZC",
  "ICPENXBSUEUUYONKFI",
  "XZGYUEKLNASVQQWPNS",
  "CUUKMAZCNFFWQLREKR",
  "ETBQZDLPPWDIUCWING",
  "XSDWMNYFKGUBZTRGTX",
  "OTVQHRWXZAVXSCNPBW",
  "SWOZTQXUTGBYGDEJGF",
  "SGIMQAKBZQTKAHLQDI",
  "LWOHCQVDZHMBXXXZUR",
  "ILQMPWHLPLKBRKZSIC",
  "YXKFSDRCTMERRVVQNU",
  "KMNVYKQCLNZPDSJJLT",
  "QUATSRJZXVWUFLDBIQ",
  "TOIOZZTDJGLKDAKXPF",
  "TWMELMCUMUZFILXCCH",
  "GCFSUMQQKVRZWNQIIE",
  "XPXAJTQGEDFRKUBKJB",
  "MPMNPAWTGHJFFGBOCB",
  "KEGYUIPOLALZFJHBRM",
  "OKADBQSYFXXIWLRHZP",
  "WIVIKWIDKBYIMZUIWG",
  "PVQPTCWGXHUVYDBPIE",
  "YOBPWSJRUENTLQVWZF",
  "AZEMJSXWKETINZZOWQ",
  "WDUTKZCYBSHQVNLVXX",
  "TWOLOEUIUZLODPBZZT",
  "YIBPZNKCVJFRYAUPCP",
  "HLGZISVRMHTQMZAEWG",
  "KSISSDVGJQYZNPFBFY",
  "NJENUGLTFPYNMIHCPP",
  "GYVCZNIXXMKBWHPVKP",
  "EDOSWUKKWXNHJVMFOO",
  "IHPHQISGGIAKOBULYQ",
  "VZIJCKNRKLLYQITSJL",
  "RAJWXXQSCMBUEMYOKU",
  "CNNAYAEKCUTWVOWLTY",
  "QKTHKFNBJOFRQUFKEK",
  "RVSEZKGFWZITKUDHJN",
  "BPLKLZLBXXUVNEUHYR",
  "TOBJDYMIVWDKPMRAMU",
  "WYPSKFGPNRDEMNIIYU",
  "PNGZTZUVTWZQBLHPIW",
  "NFBWZGQBXFBXMAQVGJ",
  "EHZCUPTVZFOEHQXIBA",
  "DTZOYHONISECWDREKT",
  "ZXEZCURJISEGLCMTMO",
  "RCXJBWBMBYOTIDAYKQ",
  "BRVCQMWAKJTPHGUVJK",
  "UEYLRFCGRQXQZOEGPT",
  "NWTCDZCWRVSYERIQWQ",
  "ILXDSKETDSYYKJVNIQ",
  "GLPHSMRJHUCBFVVICW",
  "BIUVZBWLNWUARTAOER",
  "CPUXNTEXEOEZRSCMQK",
  "FKHBDAXRSRMMULGNKI",
  "PEGEQHVDJORYSZHJPE",
  "CYWRFVMDVKMOCGQASG",
  "PNXNGQZQCEKOTQZTCV",
  "RVQSUCXBVTZZWYCIFI",
  "LOAKDJBNIOKXVHZYPF",
  "SNLNKQUALTRLQKJHFF",
  "ILAUKELPAGJBEOWBIP",
  "FHWSHYZKTBAWRLPDIC",
  "GGCZIEQGSLKFJHZMHS",
  "EWSCFZOITPOFKODJJU",
  "KIBSBZJGAHRMXOOFCH",
  "XVGFPGKTSEPSNLKBIN",
  "PKUXYNOSDRFBWMSDMU",
  "EZUIHBUPBMYRGLBIYS",
  "OUXJYNYAMLQYOIGGKX",
  "VZQYGIOMIMQYWNGQQP",
  "VGFQUTVOUJEURZDWUP",
  "QRDMZWACWPWVUCWCSZ",
  "KCNZLOZUMAOFIKOZSD",
  "JTYZIKFFGZGJQRGMWT",
  "PHAHXRTDJZAOLPJBUS",
  "ZLIXZCTAHHLNSMEJPP",
  "BEOMQFNPEKPDRXGKJQ",
  "JTBHGMAJWXALKQUYUA",
  "HCYOSTCZACEDRMFNIE",
  "MGJKJLLEZWVAHMPEOL",
  "FBIRRHVAIPKLTSODDL",
  "MTZMCONNHEXCTGXPKH",
  "CJCOCVWGZUPTVXUZNR",
  "BUFFWNZGXHCLMVPOBW",
  "EKKSFJMSMUUNVRNBAD",
  "RAAPFQUIFHRQXVJVFB",
  "RZYJVXDWRYXOJFBLGV",
  "FMHZRPYBSQGXPYDNUS",
  "PARUYLBFWCIHXVDGLW",
  "SIFILSBRCDXXJNOXWX",
  "FYQMVNDSBPMGGSDJBK",
  "CGKLIUPKCBLDAGXSUQ",
  "FXXLONHTUCZSLQIIFE",
  "SEJLQUSNYHIEVARMKJ",
  "MXTAZBAJBJGQHIFAPP",
  "FKKLVTCHDEFBPVWUFW",
  "HAIGDITSWJJTKEJBCD",
  "UEHQYWDBNQCCFKKARE",
  "BIPEEINSCUODKJHPCE",
  "GRNPHZOAUCXBWIKUDY",
  "ECAKDFVLRZHWFMRUON",
  "JFHVLMBOQXPLVZJCWE",
  "IVCWTFDAKYYJFCPWCT",
  "SIAAMMCHYPHJTEQKSR",
  "AVNDZTRISQBWPDYXSK",
  "NGAUCNBRBQJOMJHMJM",
  "QYSODHYTWAJKZGLSGR",
  "ZTGHADBPOTXXMTCUHN",
  "LIYFXVMCFZWTHGKYUE",
  "EYCBOCVMJZVABOSUGF",
  "WCQVSFAJTRFILGOEPX",
  "VCITDDFPGBUTSLVYKN",
  "GUICIMFXMCTEVRUYCQ",
  "CBCWRTUJFPWKEULACI",
  "PSZJYAXRDWLMQXRZDF",
  "FQOJJHMIHAHZFMXTGE",
  "ONARMOZERTVCIYRTGM",
  "QUSABVTRRUCINPFQNN",
  "USBGANFMQPYXTRBVPQ",
  "TBLGSUSQQDQQRLQRDP",
  "XMINJBCVKLUFFFETCC",
  "SLEEXICXNDBWGSJBPW",
  "MBOTNPLTOEQCBCENDK",
  "EXROFWFAGPNYVIQOTE",
  "DVRDFZCZSFVMLTBRFI",
  "ESUGXXZVCDVYAFGJWA",
  "XAMWRRDGAFTLZTFTAP",
  "PUORTTFMZIBVDPRRLN",
  "NZGLDFESMSKCCCEWZN",
  "OFHGUMNAJIQSREDZIW",
  "QCSWGOKWFSIUOMIRLQ",
  "DESAIZYQJMDECUDZGD",
  "MRONVCTTEUARXSUVAA",
  "MKEAPOCLVCWDOUUAHN",
  "ALGSDVWLEEKMCYXHVU",
  "ZMYGSCSRLZJJUAVRXX",
  "ZFHQRJTUKMZQNYVIAE",
  "YEZBHQNKSMOGYIKWZV",
  "HQQIRSFXOIGDKRVTSD",
  "HYVWRAZJMVWYLDHYAP",
  "XAGLQTCQOTDVJJLPMG",
  "ZBVWESPYCIPKAQUJIR",
  "KSWBMUNHNEYVLVUIVS",
  "YHNDOGFYVNCWRXGTAG",
  "NERMANERJFUULUFBFI",
  "XGWLHTCAOHDUFKQXRQ",
  "MJLXXQUODIODJLKEHC",
  "VIFNODPUNVXCWVYWLO",
  "XSHOUPPRHUEOWZNOAD",
  "XFQHOWFFQKTMIRZGWZ",
  "DMGNQBMGYQPEJKMLYT",
  "LHHAVKMTBPCOEGLMFV",
  "BPTRYWNKWXXJNYNBSO",
  "EMEIMBHJMVFBCIQFLW",
  "XEJUZFDXMPAMRDIMCP",
  "PCWOEMYOAGOQMCHRDK",
  "QBPKXTXZJAJRVMMDKD",
  "ZKBSLAZNHIRIIPRWZQ",
  "JJWJHHWIONXTQFPGKL",
  "UKMMXUIYWDQOMEAGPK",
  "KPAIOTANJRINDIQJTV",
  "CIGUUCTJEBAAGFWKLX",
  "MISKXHDEETCYBXTXNJ",
  "ZKOZMPXLTHQQBKUUJX",
  "SLDAAXFSHCWHLEEQDV",
  "KOKSSEYIFOADCMAKTB",
  "PZQDGUMUXSVLVQEUZH",
  "GLQSIDXGHCCAOJRUYF",
  "VCJIZALIUHWGYELCMZ",
  "MNNIHGIMKJVQSZLXGH",
  "JTMOJNYTVVQDLFUGWM",
  "JCRAHVLZKCRNBBKQFN",
  "UKLHPBVKEWQFBVKDAE",
  "IJFOYSMZUKHZVOQEEC",
  "WLJICNOAVLDCISBFVR",
  "UUOPSXGCJOOSINOUCU",
  "EQGTQDPUIICFREFAXW",
  "AASEHRDQBGDZWDGXFK",
  "DTNBEUVWGBIARGSXDP",
  "IMRMOYIVNOQCFNVGEV",
  "CFGXMCVJMCXQWRSSTU",
  "AWSWCMVRYCJTKPRWGZ",
  "PVRBOYBVUXGACCUDKI",
  "UZRCSYMGUWXOYVCPPA",
  "YIJLBNCMXZZISQXMXH",
  "WKDQJPNFGQEDZZWOHI",
  "PYDYRWUKWQTDAFUBKL",
  "OGVRQUXNUFIASLCKFI",
  "TSDSWKQZBZNPRPJTLL",
  "PYNYRKOZWROZDFKWHN",
  "NXCHBYOKGQWUESVNYQ",
  "SXTNZABSKIHVLZHKCD",
  "JRAUSMQHOVUNWSDASV",
  "OSBVGQCKKNNPQFHAIY",
  "TBQXLTDJJVNZSZSCHW",
  "ESNGUIDFHIYDAJCLFK",
  "SNCQBMLDNDOXFQQDPL",
  "GIEJOVHPURXWSTRXFZ",
  "NLETFDUJHYLRXFBVYI",
  "VDEZXPHIQBMBPJQWMX",
  "JSPBQRWUAXAHYIQSDG",
  "UBHRMQNMCOOENYYDOP",
  "EIHOQEFCVNXJKRQLIF",
  "SKPIZRPPBGRCINKHXB",
  "CGUHTTFYDKSCJEWEVQ",
  "HKIGEAPBMTSVWEOZEX",
  "SKKBQHQWCILPRMJRJN",
  "GJLJZOWIJUNMRXLIVI",
  "RCCBOYTORCLVYSHLUF",
  "FVEVZCNXUVYHZYROYA",
  "MSQVXMUTSCYJJPDICP",
  "YXFCLQPSAZEKQIHONY",
  "WLBSFXWONYUJSPHRAG",
  "DGVBRNQZVUGPZWYOFB",
  "VKMPQLKAFYSHWTMELU",
  "AYFGJOTTRUOGRAAFMG",
  "JERGMIGKYJGATNAUIB",
  "WOVHTPJCFMZNUZUMXQ",
  "YEICBNVIHCJUXRVHNX",
  "GXLOHIEYSZDDASULXQ",
  "MQYSBBHVSJAALKHMTW",
  "AEZJYINJUANSIYZCSX",
  "CKDJNALEHSBQPIFWDV",
  "EBROWWDBALMVSZXZMD",
  "DGGWXDLOECHMNIKJVN",
  "ROWDNKUCSNALGDRIMX",
  "VXACRRIMMLWKULNTGM",
  "WPEGYYVBVGCWDHSVAN",
  "GIRKSSZLADWILUWCNX",
  "NZSXZSUCYIHNQDXSAP",
  "UXNBOTLITLEMYQPZWH",
  "TVSACNLCJLEUWWKCPZ",
  "POVWHFQRRKYSZKELWH",
  "RQRVYBNCMIBCGJDEUO",
  "LGGXIVSQYRKZRATDFI",
  "NGYXPSMGZQHQAVXDMA",
  "MAGBOUEOJXWNSTHGPY",
  "TEKRHJQIDKNLBAEDYZ",
  "WNUEYXIWATDZVGXDOM",
  "XTBRKKMIATEESBTSCG",
  "IHLMVQRHISBAHTCSME",
  "ODOBGXSSLCRLCHMJWA",
  "WUCREAALEKHGKEITZK",
  "LYUJLKYYCNPYACSYTR",
  "FBHPIHCAYGBZXRZDWY",
  "XAZWIZWFNSTTLHCJPD",
  "VDCQPGZZJSSABLAVDS",
  "QBFLQNHAXKQJEXVHMB",
  "HOLRMQNBMDYHSEBDLP",
  "OYYSNXMWQPSWZMJRYJ",
  "JWVJCLWVGOFAPGNHUE",
  "RKFLCSDJRBENGVPURO",
  "CYEUIWILOSMETEEVKJ",
  "NFXGCZBDEMCMJBOMTQ",
  "EUNZJKIJMVHOONDOHG",
  "PTSLVNMJOUTQIKNDSR",
  "BQWVLUZEMMZBCLWCQQ",
  "TBTUVWDXDCEFYCXPQE",
  "SYUTVXZZKPDDTSPTCH",
  "GJZNDPTJKGQSEUXDVO",
  "FMCKOWUGWRXDNNLIYY",
  "EJLKVDCOPSHHJZZUTX",
  "DDALBKFEZBCAUHCAKL",
  "MFACIRWCHJMLGCRGNQ",
  "NCUMFKLVAIAIFPMFTO",
  "PRTQQJHHSVNOONXOLP",
  "AAQJVMQBHOGYDKYOXX",
  "EBFZJTFGUEHOXXBPAI",
  "LXJFBATZTXVPIWQXUE",
  "XJXRCHOTXBAIQMTJFQ",
  "EQKIBWQFLMSBXVRERY",
  "QCADRLNHMFSAERZSII",
  "XQHPGJKVZZOLXJOPUC",
  "EVIGIJPRFANZCEBLLS",
  "RURMDYPNXFQKYETGVX",
  "HYMUZXARHCUVSEQYVB",
  "IOWNZEJUXHIWGTLQEU",
  "ICLBYARKRSPGVWQOOT",
  "AUISTLOWKTIPWZNQMF",
  "JCOKSSLONKWZLMIJAH",
  "BRXPWGANBZJAOEIUWK",
  "XTEQSYROFPTNIJPAQX",
  "IZVZRUYDWSUJXANGSY",
  "SZGUHBGDTNEULMTGTJ",
  "IKWXVTXHTCRMMQALXU",
  "KIVBLOQYOZNMAHABCG",
  "VSVUUVWQRMDWLOVFTA",
  "CCJIQVABMRGLBAJVEE",
  "JJVJRVWXULGQNPZNLK",
  "ZBKNZCKEAVLRQKYGHG",
  "WXBEBYOUORQUIKKUNR",
  "DSMGTFAMBYBWEINORZ",
  "QSPARJYDVNARKJQLZA",
  "YJCBSTNEPJNRYHMDPX",
  "VCDLBMLYGGFNBHEGAA",
  "RVNMUTYEJGSIDZCCHR",
  "SACQKOHTRESDXYAUTN",
  "RGKSIHBZTGWIQKNITF",
  "BTUTMCVSITCFERGDTN",
  "GZQKQRUCPXYVYGLJYW",
  "DVHAACNLBYLXSGGUNS",
  "ALJUZXDHWDFKPDMZGZ",
  "CNXODRBOIRLENUYPOI",
  "UGOYWLTQACZIGHZWQX",
  "WFEVKSGMDVXORCTQJL",
  "TYRMYZNSTAVRAHOPKQ",
  "WHXUFTWQNYPXGWALTB",
  "VXFPYUIPSGPNSPUBOZ",
  "PIVUWGRORLGJCDUSXH",
  "QHBCUBSNPZSOJQDXTC",
  "FXYXBILUOVYVGBZSUE",
  "YZLWTPRQWWZKOIEUXR",
  "HROVJIXKWYANUTDZOM",
  "GINHPDCYGZTMRFBLLG",
  "PJVTLIFVYXIUTMYNMK",
  "TLUDEASLPEYJUZQPGG",
  "ONGPSMRJFNAYHDMABQ",
  "QRZQMFBBLDCKIIMLQX",
  "TUEPZEKZJTOAWKAVFD",
  "YKEHITAMTDLFNLBVKB",
  "XNAHJNLIULNSXYMVFJ",
  "MOQVUAMWPDTACUITAD",
  "THEUNTXXLAYOTFNHUP",
  "SJMUDVXLOZXIADRMBI",
  "QTSRUCRDAATPHQFWAX",
  "UOGPWBDQCYIGMEYSDY",
  "VNNMJQJUFPRAULLNTJ",
  "GITTEFCJWMKUDKLNTS",
  "WXGLQSYKGBVEZWBPHR",
  "NCHKALJPTLSYUVFUND",
  "IAZRASJYMPTEPLRJSK",
  "HVZCAZKPGBJADGVEEH",
  "FPUZPGGCWAPZODAFGF",
  "IMVUCRJMPSALOTNMMM",
  "EDLKIWQQAIOMENSBHM",
  "PKYJGNKOPWADGFTHWR",
  "MINEXMASJOPXAOKRPN",
  "XJBNHRYUXKMPQTLZPG",
  "ZQJJNYCTEKUWXSMWVX",
  "WPDQUFYSJQVNXYCEWQ",
  "BACVNMJWNIKZSBXHGN",
  "YEYNQTFRRVYLTZOFVF",
  "TRJEKEWLOXGALISJDC",
  "DYZVWPHWYSRCSBXVYH",
  "DMARPOEPITCNKBVHEU",
  "KCQYIBMZSJDHBMMPPW",
  "RMKBSCQQAQUHJICKTL",
  "CKUFLJEBATZAJWSZRI",
  "KBUXHDILTQMPIWTTXG",
  "SWRDRMGHCZWVEOIXUS",
  "LVZTQEXBCDBFQUBNBO",
  "TMUQOWXYGNHLIRWHOY",
  "UWPRQYALPISMDZREYS",
  "VNQRWZZNVYFNGAPWNE",
  "VDBMDGYTYBEBIAMLHU",
  "JZXSKWRSBODWALWHBJ",
  "ICQAFNRTAZMUXRBMKP",
  "OMWEGRUVRZZPAGGENK",
  "ZNCXYYQKTLVRHVAOZD",
  "IRGUDPUSDKGSSOOYNI",
  "TCWKFWDIYYLZCINLTM",
  "TKWCQTJYTLWGDBJYPJ",
  "NZBTKMSFCRNZXFQCSK",
  "TLUOLNCJMFEXMJPKLT",
  "PIYWJUNGOTJEXHLIMA",
  "ITGCEFXSHNOEYUWDZQ",
  "SRMLVMTKKNCLUYJSFA",
  "IHLPFUWBJMDLTZCRBC",
  "QESERBXTMSFCJGPVAS",
  "JVDVZUEBAQRPSVLCSI",
  "LLWWSUXJDFQWVVDPTX",
  "YUMCQBCXNFFWGMUGDR",
  "GEWLVDCNHRYYKCJSGC",
  "GTKIXPILFCZYRXMDNU",
  "QJRCEAVNFZYJSUCWQE",
  "ZNOOPYBSRXABSHREBG",
  "WDBEEAAANTSZHLMMNC",
  "QPTOZUQPSJBVPHKXYB",
  "PNWRYTZKMRRDSKEOSR",
  "FEUKNOUSQNEHCLAKRF",
  "IBGQJHRVEFQIJUEQGZ",
  "QBHXAOREEXNYQHZSJP",
  "IXSOULFDBCVZHWGDZI",
  "HMGMCNEKMRMKEGYNWE",
  "BXLPFEIEDNEDHJXGJZ",
  "YIUAZKRZFCQRMTKWPV",
  "WLYNXPNQMBBNWKTYEM",
  "GZHKNRUBTBYZWVLDIB",
  "PLCINXHSODOQJOSGRJ",
  "IUWNVLHURDDNTMESZB",
  "FVWCSSOOPSOSMPYIBO",
  "NXYZNJFEIGGDJIUKCC",
  "FQCLYBCGIJSCENGFIP",
  "ZSFLYJEQGDIXLBNITF",
  "BHAWBPGYPDORTXLCVQ",
  "NLRLPBEEKZIUGQXHEJ",
  "XIMLRSNCLFNQGUOAAP",
  "RKXSLENLLLRZZJPIRC",
  "FCHRQPIJMXLIZFBZJS",
  "OQFPHYQMDQVCJRUGRT",
  "MOUCWFKADYVJTLVPCA",
  "MNKWPSDOUCBTTNHVAL",
  "BQNNEPKGPZNFGUJNIM",
  "UNMDTQAECMRPGILOER",
  "TYQOAITWQBMUDEWLDU",
  "BIAUUTLEQKVMMMXKSF",
  "NWXHSIDVHTTUYLWUCE",
  "UPSNVIJFRNIGNHPDPX",
  "DGEQJSHBOVVKRNQRUP",
  "XXDESZCBIYVMYUVXSB",
  "CEOSMCNVEMKBLDDENI",
  "YLYNFUBTEIUKMFJJLL",
  "PHVOCAGUDIKRVZWPFI",
  "VRGHJYPJYMFOSSHQOI",
  "CHVSOEJDTQGZZUTXXI",
  "HRXOJTAREAWXRDZFOM",
  "IZILJAPFLTWYEPLISL",
  "JEQKIABDPBEPMZEBSW",
  "NYIUMFEDUJGJAQPNMN"
];
  // Day-specific canonical compatibility overrides.
  // 2026-02-11 shipped with this start state for accepted leaderboard entries.
  // Subsequent entries pair with DAILY_WORD_OVERRIDES on the server — must
  // stay in sync; the CI parity check enforces this.
  const START_STATE_OVERRIDES = {
    "2026-02-11": "ZRBRCMASBETKKBRLUW",
    "2026-08-10": "NAZKQOGIEUXWXDSLDC", // word: GINA
    "2026-08-13": "PHIJFCHYQQNAMLUBDP", // word: CALM
    "2026-09-27": "BINXCAMDCCUXBYSZNL", // word: ABBY
    "2026-10-05": "XJAKWNEEJWZPSTDIBS", // word: KIND
    "2026-11-20": "DHXKAGPPDBODWVBYQL", // word: GLOW
    "2027-01-11": "RPSIGKJFQSMCHTVBNH", // word: MINT
    "2027-01-12": "ZUDXHHTUHCYSEGKAJR", // word: SAGE
    "2027-02-06": "LZOJCPXCCWAFUMSKRF", // word: PLUM
    "2027-02-28": "RKKLQFLHYLSINEAUJJ", // word: FERN
    "2027-03-01": "EVGSKBHDTVPYXCIMNF", // word: PINE
    "2027-03-13": "MWPGALVZPZCJKEWOWJ", // word: LAKE
    "2027-04-24": "OZGIADTEVHTBNTPKCW", // word: DAWN
    "2027-05-10": "JVABZMQBKISOLVHYSL", // word: MOSS
    "2027-10-19": "JYCBEZVBCHLQDBYCRE", // word: REED
    "2027-10-24": "YZAXDUHTPPXBENRPIV", // word: DUNE
    "2027-12-02": "BZYKGTOBQYGIEQNOXD", // word: TIDE
    "2028-01-01": "LCEFRGSBYZHZODMWVK", // word: GOLD
    "2028-01-11": "UVPOJMEKQZODUBOZMA", // word: JADE
    "2028-02-03": "SRCXIPISQNOUALYYIM", // word: OPAL
    "2028-03-24": "IZQRPRJWFTNSKLVPFP", // word: SILK
    "2028-03-26": "UDNTWOXFAVTPLTPAEO", // word: WOOL
    "2028-05-22": "ONQWAMUHJNLUHKVOUH", // word: LOOM
    "2028-06-07": "GLYSAHMXPDLQRKVNOC", // word: HARP
    "2028-06-19": "APZHOBJCDKVWLUZZQR", // word: LARK
    "2028-09-09": "EVXOAWOJAMUFRNDJIH", // word: WREN
    "2028-10-07": "GBAAODWGLJXMEWSJFV", // word: DOVE
    "2028-10-17": "VRSZHWAKBXUOVNDUOJ", // word: SWAN
    "2028-12-08": "DUOZWFQJTVXOANDMHZ", // word: FAWN
    "2028-12-13": "AYDBDMFFLMPREODCWH", // word: HARE
    "2029-01-22": "FRBDBZLSJXWRGAZQET", // word: SEAL
    "2029-03-16": "WCTECMFALFHYNKECOO", // word: MOON
    "2029-04-11": "AOXDTSHJMCDMIRLBOM", // word: STAR
    "2029-06-27": "IKPLMEPCMQQANJWYGR", // word: RAIN
    "2029-07-06": "KIVRSNQTPYGLOIWXAC", // word: SNOW
    "2029-08-05": "CWCFMIZQUZBVTHXXDS", // word: MIST
    "2029-08-11": "SLNFZHJGFCRMEYTNNA", // word: HAZE
    "2029-09-05": "NSPKLGDPOCAYEKIDSM", // word: GALE
    "2030-01-04": "KSLJEPGBUJSFAIUOUS", // word: PEAK
    "2030-03-06": "KFMWLACMYSVREIIGSR", // word: VALE
    "2030-04-09": "NYWZETLOCUIGCWKCWV", // word: GLEN
    "2030-04-18": "BVLMRCRFGXHLOEISRU", // word: COVE
    "2030-04-23": "YNGTZTFNKIFHLEUYOS", // word: ISLE
    "2030-05-09": "EFMTTLXWYDUNAQOVDV", // word: LEAF
    "2030-05-17": "YUVTSRAXXWAXEPFVON", // word: ROSE
    "2030-06-26": "OQWJGRTJVWZLIYOOAL", // word: LILY
    "2030-07-06": "DHBBIIDLPUXZSNMNPR", // word: IRIS
    "2030-07-11": "OFATMVHIATMJELTYHN", // word: VINE
    "2030-08-26": "QMFPGXEOXELTAKVRBK", // word: LAMP
    "2030-09-29": "GHUTOPMYFOVCEATTUB", // word: PAGE
    "2030-10-15": "FKXUPNSEQARUTUGLXR", // word: NEST
    "2031-02-26": "UBYTKIDHJWNCEWLNHV", // word: KITE
    "2031-03-17": "JDXHBEOYPNBRUQHPMH", // word: DRUM
    "2031-05-02": "BMCZRHTVZMCXODPBLA", // word: HALO
    "2032-01-23": "NLEMUAVZOIIQRKPZVA", // word: AURA
  };

  function getStartStateScheduleIndexForKey(key) {
    if (!key || key < START_STATE_SCHEDULE_START_KEY) return -1;
    const [year, month, day] = key.split("-").map((value) => Number(value));
    const [sy, sm, sd] = START_STATE_SCHEDULE_START_KEY.split("-").map((value) => Number(value));
    const startUTC = Date.UTC(sy, sm - 1, sd);
    const dateUTC = Date.UTC(year, month - 1, day);
    return Math.floor((dateUTC - startUTC) / (24 * 60 * 60 * 1000));
  }

  function getStartStateForKey(key) {
    if (START_STATE_OVERRIDES[key]) return START_STATE_OVERRIDES[key];
    const idx = getStartStateScheduleIndexForKey(key);
    if (idx < 0 || idx >= START_STATE_SCHEDULE.length) return "";
    return _d(START_STATE_SCHEDULE[idx], idx);
  }


  window.PivotDaily = {
    hashString,
    mulberry32,
    getEasternDateParts,
    getEasternKey,
    getWeekdayIndexForKey,
    getScrambleMovesForKey,
    START_STATE_SCHEDULE_START_KEY,
    getStartStateForKey,
  };
})();
